/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/agents_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import { AgentsServiceAssignAgentManagerBody } from '../models'
// @ts-ignore
import { AgentsServiceCloseTicketBody } from '../models'
// @ts-ignore
import { AgentsServiceCompleteAgentTaskBody } from '../models'
// @ts-ignore
import { AgentsServiceConfirmCompanyAssignmentByManagerBody } from '../models'
// @ts-ignore
import { AgentsServiceCreateAgentTaskBody } from '../models'
// @ts-ignore
import { AgentsServiceCreateClientCommentBody } from '../models'
// @ts-ignore
import { AgentsServiceCreateDealCommentBody } from '../models'
// @ts-ignore
import { AgentsServiceCreateDealTaskBody } from '../models'
// @ts-ignore
import { AgentsServicePostAgentTicketMessageBody } from '../models'
// @ts-ignore
import { AgentsServiceReplyTicketBody } from '../models'
// @ts-ignore
import { AgentsServiceRequestMeetingBody } from '../models'
// @ts-ignore
import { AgentsServiceSetAgentCommercialTermsBody } from '../models'
// @ts-ignore
import { AgentsServiceSetAgentOfferStatusBody } from '../models'
// @ts-ignore
import { AgentsServiceSetAgentStatusBody } from '../models'
// @ts-ignore
import { AgentsServiceSetRoutingRuleEnabledBody } from '../models'
// @ts-ignore
import { AgentsServiceSharePresentationBody } from '../models'
// @ts-ignore
import { AgentsServiceUpdateMyPresentationBody } from '../models'
// @ts-ignore
import { AgentsServiceUpdatePartnerCompanyBody } from '../models'
// @ts-ignore
import { AgentsServiceUpdateRoutingRuleBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1AgentClientComment } from '../models'
// @ts-ignore
import { V1AgentDealComment } from '../models'
// @ts-ignore
import { V1AgentDealTask } from '../models'
// @ts-ignore
import { V1AgentPresentation } from '../models'
// @ts-ignore
import { V1AgentProfile } from '../models'
// @ts-ignore
import { V1AgentTask } from '../models'
// @ts-ignore
import { V1AskCommissionResponse } from '../models'
// @ts-ignore
import { V1CheckLeadUniqueRequest } from '../models'
// @ts-ignore
import { V1CheckLeadUniqueResponse } from '../models'
// @ts-ignore
import { V1CompanyVerificationResponse } from '../models'
// @ts-ignore
import { V1ConfirmCompanyAssignmentByAgentRequest } from '../models'
// @ts-ignore
import { V1CreateAgentRequest } from '../models'
// @ts-ignore
import { V1CreateMyPresentationRequest } from '../models'
// @ts-ignore
import { V1CreatePartnerCompanyRequest } from '../models'
// @ts-ignore
import { V1CreateRoutingRuleRequest } from '../models'
// @ts-ignore
import { V1CreateWebinarRequest } from '../models'
// @ts-ignore
import { V1DeleteAgentBotLinkResponse } from '../models'
// @ts-ignore
import { V1GetAgentBotLinkCodeResponse } from '../models'
// @ts-ignore
import { V1GetAgentBotStatusResponse } from '../models'
// @ts-ignore
import { V1GetAgentDashboardResponse } from '../models'
// @ts-ignore
import { V1GetAgentDealsResponse } from '../models'
// @ts-ignore
import { V1GetDealFreeSlotsResponse } from '../models'
// @ts-ignore
import { V1GetTicketResponse } from '../models'
// @ts-ignore
import { V1ListAgentTasksResponse } from '../models'
// @ts-ignore
import { V1ListAgentsResponse } from '../models'
// @ts-ignore
import { V1ListClientCommentsResponse } from '../models'
// @ts-ignore
import { V1ListCompanyVerificationsResponse } from '../models'
// @ts-ignore
import { V1ListDealCommentsResponse } from '../models'
// @ts-ignore
import { V1ListMyClientsResponse } from '../models'
// @ts-ignore
import { V1ListMyDealsResponse } from '../models'
// @ts-ignore
import { V1ListMyPresentationsResponse } from '../models'
// @ts-ignore
import { V1ListMyReferralsResponse } from '../models'
// @ts-ignore
import { V1ListPartnerCompaniesResponse } from '../models'
// @ts-ignore
import { V1ListPresentationSharesResponse } from '../models'
// @ts-ignore
import { V1ListProjectMaterialsResponse } from '../models'
// @ts-ignore
import { V1ListRoutingRulesResponse } from '../models'
// @ts-ignore
import { V1ListTicketsResponse } from '../models'
// @ts-ignore
import { V1ListWebinarsResponse } from '../models'
// @ts-ignore
import { V1OfferDocument } from '../models'
// @ts-ignore
import { V1PartnerCompanyResponse } from '../models'
// @ts-ignore
import { V1PostAgentTicketMessageResponse } from '../models'
// @ts-ignore
import { V1PresentationShare } from '../models'
// @ts-ignore
import { V1PublicPresentationResponse } from '../models'
// @ts-ignore
import { V1PublishOfferVersionRequest } from '../models'
// @ts-ignore
import { V1PublishOfferVersionResponse } from '../models'
// @ts-ignore
import { V1RegisterForWebinarResponse } from '../models'
// @ts-ignore
import { V1RegisterRequest } from '../models'
// @ts-ignore
import { V1RegisterResponse } from '../models'
// @ts-ignore
import { V1ReplyTicketResponse } from '../models'
// @ts-ignore
import { V1RequestMeetingResponse } from '../models'
// @ts-ignore
import { V1RoutingRuleResponse } from '../models'
// @ts-ignore
import { V1SearchPartnerCompaniesResponse } from '../models'
// @ts-ignore
import { V1SubmitInquiryRequest } from '../models'
// @ts-ignore
import { V1SubmitInquiryResponse } from '../models'
// @ts-ignore
import { V1SubmitLeadRequest } from '../models'
// @ts-ignore
import { V1SubmitLeadResponse } from '../models'
// @ts-ignore
import { V1TicketActionResponse } from '../models'
// @ts-ignore
import { V1UpdateMyProfileRequest } from '../models'
// @ts-ignore
import { V1Webinar } from '../models'
/**
 * AgentsServiceApi - axios parameter creator
 * @export
 */
export const AgentsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary ArchivePartnerCompany — архивирование (удаление запрещено, ТЗ §13.3). Системную «Частный агент» нельзя.
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceArchivePartnerCompany: async (
      id: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceArchivePartnerCompany', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceArchivePartnerCompany', 'body', body)
      const localVarPath = `/api/v1/agents/companies/{id}/archive`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary AskCommission — DEV-346 «Вопрос по вознаграждению». Есть дата выплаты — вернуть; иначе создать обращение commission_question (маршрутизация) и сигналить «дата уточняется».
     * @param {string} dealId из path
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceAskCommission: async (
      dealId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceAskCommission', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceAskCommission', 'body', body)
      const localVarPath = `/api/v1/agents/deals/{dealId}/commission-question`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetAgent (`GET /agents/{user_id}`) объявлен ВЫШЕ — перед GetMyProfile — из-за порядка матчинга grpc-gateway (см. комментарий там). НЕ переносить его сюда. (DEV-509)
     * @param {string} userId агент (из path)
     * @param {AgentsServiceAssignAgentManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceAssignAgentManager: async (
      userId: string,
      body: AgentsServiceAssignAgentManagerBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceAssignAgentManager', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceAssignAgentManager', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/manager`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CheckLeadUnique — проверка телефона клиента (защищён, роль AGENT). Данные найденного клиента не раскрываются (§16).
     * @param {V1CheckLeadUniqueRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCheckLeadUnique: async (
      body: V1CheckLeadUniqueRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCheckLeadUnique', 'body', body)
      const localVarPath = `/api/v1/agents/leads/check-unique`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} ticketId
     * @param {AgentsServiceCloseTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCloseTicket: async (
      ticketId: string,
      body: AgentsServiceCloseTicketBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServiceCloseTicket', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCloseTicket', 'body', body)
      const localVarPath = `/api/v1/agents/tickets/{ticketId}/close`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} userId
     * @param {string} taskId
     * @param {AgentsServiceCompleteAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCompleteAgentTask: async (
      userId: string,
      taskId: string,
      body: AgentsServiceCompleteAgentTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceCompleteAgentTask', 'userId', userId)
      // verify required parameter 'taskId' is not null or undefined
      assertParamExists('agentsServiceCompleteAgentTask', 'taskId', taskId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCompleteAgentTask', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/tasks/{taskId}/complete`
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)))
        .replace(`{${'taskId'}}`, encodeURIComponent(String(taskId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {V1ConfirmCompanyAssignmentByAgentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceConfirmCompanyAssignmentByAgent: async (
      body: V1ConfirmCompanyAssignmentByAgentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceConfirmCompanyAssignmentByAgent', 'body', body)
      const localVarPath = `/api/v1/agents/me/company-verification/select`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceConfirmCompanyAssignmentByManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceConfirmCompanyAssignmentByManager: async (
      id: string,
      body: AgentsServiceConfirmCompanyAssignmentByManagerBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceConfirmCompanyAssignmentByManager', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceConfirmCompanyAssignmentByManager', 'body', body)
      const localVarPath = `/api/v1/agents/company-verifications/{id}/confirm`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateAgent — ручное создание агента менеджером (DEV-470, ADR-0016): заводит PENDING-креду в auth + профиль (created_mode=manual, status=candidate). Дедуп по phone/email/telegram. Права: ADMIN/HOS/agents:manage (requireAgentsManager + privileged).
     * @param {V1CreateAgentRequest} body -------------------- Ручное создание агента (DEV-470) -------------------- Менеджер заводит агента до его входа в панель. email обязателен (PENDING-креда в auth); company_id обязателен (ТЗ §6 — компания обязательна; для одиночки — UUID «Частный агент»).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateAgent: async (
      body: V1CreateAgentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateAgent', 'body', body)
      const localVarPath = `/api/v1/agents`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} userId агент (из path)
     * @param {AgentsServiceCreateAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateAgentTask: async (
      userId: string,
      body: AgentsServiceCreateAgentTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceCreateAgentTask', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateAgentTask', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/tasks`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateClientComment — комментарий агента по СВОЕМУ клиенту (уведомляет ответственного менеджера).
     * @param {string} clientId из path
     * @param {AgentsServiceCreateClientCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateClientComment: async (
      clientId: string,
      body: AgentsServiceCreateClientCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('agentsServiceCreateClientComment', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateClientComment', 'body', body)
      const localVarPath = `/api/v1/agents/clients/{clientId}/comments`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateDealComment — комментарий агента по СВОЕЙ сделке (уведомляет менеджера сделки).
     * @param {string} dealId из path
     * @param {AgentsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateDealComment: async (
      dealId: string,
      body: AgentsServiceCreateDealCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceCreateDealComment', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateDealComment', 'body', body)
      const localVarPath = `/api/v1/agents/deals/{dealId}/comments`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateDealTask — задача агента по СВОЕЙ сделке на свободный слот менеджера (409 AlreadyExists, если слот занят). Уведомляет менеджера сделки.
     * @param {string} dealId из path
     * @param {AgentsServiceCreateDealTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateDealTask: async (
      dealId: string,
      body: AgentsServiceCreateDealTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceCreateDealTask', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateDealTask', 'body', body)
      const localVarPath = `/api/v1/agents/deals/{dealId}/tasks`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateMyPresentation — собрать презентацию по выбранному ЖК (снапшот + токен; PDF генерится асинхронно). Одна презентация = один ЖК.
     * @param {V1CreateMyPresentationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateMyPresentation: async (
      body: V1CreateMyPresentationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateMyPresentation', 'body', body)
      const localVarPath = `/api/v1/agents/me/presentations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary --- Компании-партнёры (DEV-469, ТЗ §5). Authenticated; права в хендлере:     чтение — ADMIN/HOS/agents:manage/MANAGER; запись — ADMIN/HOS/agents:manage. ---
     * @param {V1CreatePartnerCompanyRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreatePartnerCompany: async (
      body: V1CreatePartnerCompanyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreatePartnerCompany', 'body', body)
      const localVarPath = `/api/v1/agents/companies`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {V1CreateRoutingRuleRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateRoutingRule: async (
      body: V1CreateRoutingRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateRoutingRule', 'body', body)
      const localVarPath = `/api/v1/agents/routing-rules`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateWebinar — публикация вебинара штатом (DEV-489). Permission agents:manage (ADMIN/HOS) на интерцепторе.
     * @param {V1CreateWebinarRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateWebinar: async (
      body: V1CreateWebinarRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateWebinar', 'body', body)
      const localVarPath = `/api/v1/agents/webinars`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeleteAgentBotLink — отвязать Telegram-бот текущего агента (защищён, роль AGENT). Проксирует agent-bot.UnlinkAgentBinding (DEV-642).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteAgentBotLink: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/bot-link`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeleteMyPresentation — мягкое удаление (лендинг по токену → 404).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteMyPresentation: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceDeleteMyPresentation', 'id', id)
      const localVarPath = `/api/v1/agents/me/presentations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteRoutingRule: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceDeleteRoutingRule', 'id', id)
      const localVarPath = `/api/v1/agents/routing-rules/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ВНИМАНИЕ, ПОРЯДОК (grpc-gateway): catch-all `GET /agents/{user_id}` (GetAgent) ДОЛЖЕН быть объявлен ПЕРВЫМ среди GET-методов. runtime.ServeMux.Handle делает prepend, поэтому later-registered маршрут матчится РАНЬШЕ, а специфичность/литералы НЕ приоритизируются. Объявив wildcard первым, кладём его в конец цепочки матчинга → статические `/agents/<literal>` (me, routing-rules, tickets, companies) перехватывают раньше него. НЕ добавлять статические GET-маршруты /agents/_* ВЫШЕ этого rpc. (DEV-509)
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgent: async (
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceGetAgent', 'userId', userId)
      const localVarPath = `/api/v1/agents/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetAgentBotLinkCode — одноразовый код привязки Telegram-бота + deep-link (защищён, роль AGENT). Для «Подключить бота» в агентской панели (DEV-341/353).
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentBotLinkCode: async (
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceGetAgentBotLinkCode', 'body', body)
      const localVarPath = `/api/v1/agents/me/bot-link-code`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetAgentBotStatus — статус привязки Telegram-бота агента (защищён, роль AGENT). Проксирует agent-bot.GetAgentBinding — единый источник правды по привязке (DEV-642 / ADR-0023). ВАЖНО (DEV-509): статический GET /agents/me/bot-status объявлен НИЖЕ GetAgent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentBotStatus: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/bot-status`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetAgentDashboard — KPI кабинета агента (DEV-489): передано клиентов, активные сделки, депозиты, прогноз вознаграждения, последняя активность, ближайшая задача.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentDashboard: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/dashboard`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetAgentDeals — сделки агента для карточки штата (DEV-780): реальные имена клиентов (в отличие от кабинета агента, где маскируются) + агрегаты вознаграждения (начислено/к выплате). Штат-скоуп в хендлере (MANAGER — свои подопечные, ADMIN/HOS — все). Данные — из deals-service (per-deal reward-поля; «история» пока там же). ВАЖНО (класс DEV-509): wildcard GET /agents/{user_id}/deals объявлен ВЫШЕ статического /agents/me/deals (ListMyDeals) той же длины — иначе later-registered wildcard перехватывает /me/deals (prepend-матчинг grpc-gateway, литералы не приоритизируются) → 403 agents:read вместо кабинета агента. НЕ опускать ниже ListMyDeals.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentDeals: async (
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceGetAgentDeals', 'userId', userId)
      const localVarPath = `/api/v1/agents/{userId}/deals`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetCompanyVerification: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetCompanyVerification', 'id', id)
      const localVarPath = `/api/v1/agents/company-verifications/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetDealFreeSlots — свободные слоты менеджера СВОЕЙ сделки (запись задачи/встречи). from/to опц.
     * @param {string} dealId
     * @param {string} [from] опц. начало окна (query, RFC3339)
     * @param {string} [to] опц. конец окна (query, RFC3339)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetDealFreeSlots: async (
      dealId: string,
      from?: string,
      to?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceGetDealFreeSlots', 'dealId', dealId)
      const localVarPath = `/api/v1/agents/deals/{dealId}/free-slots`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (from !== undefined) {
        localVarQueryParameter['from'] =
          (from as any) instanceof Date ? (from as any).toISOString() : from
      }

      if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any) instanceof Date ? (to as any).toISOString() : to
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary --- Верификация компании агента (DEV-791, RFC §9). --- Agent-facing (роль AGENT, только своё; requireAgent в хендлере): просмотр кандидатов и выбор.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyCompanyVerification: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/company-verification`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetMyPresentation — карточка презентации (владелец).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyPresentation: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetMyPresentation', 'id', id)
      const localVarPath = `/api/v1/agents/me/presentations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetMyProfile — профиль текущего агента (защищён, роль AGENT).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyProfile: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyTicket: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetMyTicket', 'id', id)
      const localVarPath = `/api/v1/agents/me/tickets/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetOffer — публичная актуальная (или конкретная по version) редакция оферты. Язык — через user-locale (заголовок). Без токена, как Register. DEV-616 / ADR-0022. ВАЖНО (DEV-509/DEV-638): объявлен НИЖЕ GetAgent — статический GET /agents/offer иначе перехватывается wildcard GET /agents/{user_id} (grpc-gateway prepend) → 403 agents:read.
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetOffer: async (
      version?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/offer`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (version !== undefined) {
        localVarQueryParameter['version'] = version
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetPartnerCompany: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetPartnerCompany', 'id', id)
      const localVarPath = `/api/v1/agents/companies/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetPublicPresentation — публичный резолв по токену для лендинга vinprop.vn/p/{token} (без auth). Трекает просмотр (view_count++, событие presentation.viewed).
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetPublicPresentation: async (
      token: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('agentsServiceGetPublicPresentation', 'token', token)
      const localVarPath = `/api/v1/agents/presentations/{token}`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetStaffBotLinkCode — код привязки сотрудника к agency-боту для уведомлений (authenticated, DEV-344).
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetStaffBotLinkCode: async (
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceGetStaffBotLinkCode', 'body', body)
      const localVarPath = `/api/v1/agents/me/staff-bot-link-code`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetTicket: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetTicket', 'id', id)
      const localVarPath = `/api/v1/agents/tickets/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary --- Задачи агента (DEV-511, владелец agent_tasks; зеркало deals Task). Authenticated;     скоуп «свои/все» по роли в хендлере. Чтение — agents:read, запись — agents:update.     Маршруты 3-сегментные (/{user_id}/tasks...) не конфликтуют с wildcard GetAgent (DEV-509). ---
     * @param {string} userId
     * @param {string} [statusFilter] open | done | \&quot;\&quot; (все). Фильтр в service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListAgentTasks: async (
      userId: string,
      statusFilter?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceListAgentTasks', 'userId', userId)
      const localVarPath = `/api/v1/agents/{userId}/tasks`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (statusFilter !== undefined) {
        localVarQueryParameter['statusFilter'] = statusFilter
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary --- Управление агентами + назначение куратора (DEV-430). Authenticated; права в хендлере:     ADMIN/HOS/agents:manage — любого агента/менеджера; MANAGER — только себя («взять агента»). ---
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [searchQuery] FTS по full_name (PostgreSQL to_tsvector), не LIKE.
     * @param {string} [managerId] Фильтр по куратору (user_id менеджера); \&quot;\&quot; игнорируется. Не-привилегированному принудительно выставляется &#x3D; себе (см. хендлер requireAgentsManager).
     * @param {string} [country]
     * @param {string} [language]
     * @param {string} [agentStatus] Структурные фильтры реестра (DEV-471, ТЗ §4.3); \&quot;\&quot; игнорируется.
     * @param {string} [companyId]
     * @param {string} [companyAssignmentStatus] requires_verification &#x3D; «компания не подтверждена»
     * @param {string} [sourceGroup]
     * @param {string} [registeredFrom] created_at &gt;&#x3D;
     * @param {string} [registeredTo] created_at &lt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListAgents: async (
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      managerId?: string,
      country?: string,
      language?: string,
      agentStatus?: string,
      companyId?: string,
      companyAssignmentStatus?: string,
      sourceGroup?: string,
      registeredFrom?: string,
      registeredTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (searchQuery !== undefined) {
        localVarQueryParameter['searchQuery'] = searchQuery
      }

      if (managerId !== undefined) {
        localVarQueryParameter['managerId'] = managerId
      }

      if (country !== undefined) {
        localVarQueryParameter['country'] = country
      }

      if (language !== undefined) {
        localVarQueryParameter['language'] = language
      }

      if (agentStatus !== undefined) {
        localVarQueryParameter['agentStatus'] = agentStatus
      }

      if (companyId !== undefined) {
        localVarQueryParameter['companyId'] = companyId
      }

      if (companyAssignmentStatus !== undefined) {
        localVarQueryParameter['companyAssignmentStatus'] = companyAssignmentStatus
      }

      if (sourceGroup !== undefined) {
        localVarQueryParameter['sourceGroup'] = sourceGroup
      }

      if (registeredFrom !== undefined) {
        localVarQueryParameter['registeredFrom'] =
          (registeredFrom as any) instanceof Date
            ? (registeredFrom as any).toISOString()
            : registeredFrom
      }

      if (registeredTo !== undefined) {
        localVarQueryParameter['registeredTo'] =
          (registeredTo as any) instanceof Date ? (registeredTo as any).toISOString() : registeredTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListClientComments — комментарии агента по СВОЕМУ клиенту (агент видит только свои).
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListClientComments: async (
      clientId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('agentsServiceListClientComments', 'clientId', clientId)
      const localVarPath = `/api/v1/agents/clients/{clientId}/comments`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Manager-facing (пермишены на интерцепторе: очередь — agents:read, приём — agents:manage).
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [verificationStatus] \&quot;\&quot; → manager_review
     * @param {string} [responsibleId]
     * @param {string} [agentUserId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListCompanyVerifications: async (
      paginationPage?: string,
      paginationPerPage?: string,
      verificationStatus?: string,
      responsibleId?: string,
      agentUserId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/company-verifications`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (verificationStatus !== undefined) {
        localVarQueryParameter['verificationStatus'] = verificationStatus
      }

      if (responsibleId !== undefined) {
        localVarQueryParameter['responsibleId'] = responsibleId
      }

      if (agentUserId !== undefined) {
        localVarQueryParameter['agentUserId'] = agentUserId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListDealComments — комментарии агента по СВОЕЙ сделке (агент видит только свои).
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListDealComments: async (
      dealId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceListDealComments', 'dealId', dealId)
      const localVarPath = `/api/v1/agents/deals/{dealId}/comments`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListMyClients — переданные агентом клиенты (agent_id из контекста, DEV-489 §11). Public-safe: маскированное имя, источник, публичный статус клиента; без телефона, внутренних комментариев и чужих клиентов.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyClients: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/clients`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListMyDeals — сделки текущего агента (agent_id из контекста). Имя клиента маскируется («Иван П.»). Для «Мои сделки» и сценариев вознаграждения/встречи (DEV-350, DEV-332).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyDeals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListMyPresentations — список презентаций текущего агента.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyPresentations: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/presentations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListMyReferrals — контакты СВОИХ переданных лидов для «Поделиться» презентацией (DEV-1016). Источник — собственные сабмишены агента; §11: canonical client-data не раскрываем. Authenticated + requireAgent (только свои лиды).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyReferrals: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/referrals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary agent (роль AGENT): свои обращения + переписка.
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyTickets: async (
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/tickets`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [searchQuery] FTS по company_name
     * @param {string} [companyStatus]
     * @param {string} [companyType]
     * @param {string} [responsiblePartnerManagerId]
     * @param {boolean} [includeArchived]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListPartnerCompanies: async (
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      companyStatus?: string,
      companyType?: string,
      responsiblePartnerManagerId?: string,
      includeArchived?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/companies`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (searchQuery !== undefined) {
        localVarQueryParameter['searchQuery'] = searchQuery
      }

      if (companyStatus !== undefined) {
        localVarQueryParameter['companyStatus'] = companyStatus
      }

      if (companyType !== undefined) {
        localVarQueryParameter['companyType'] = companyType
      }

      if (responsiblePartnerManagerId !== undefined) {
        localVarQueryParameter['responsiblePartnerManagerId'] = responsiblePartnerManagerId
      }

      if (includeArchived !== undefined) {
        localVarQueryParameter['includeArchived'] = includeArchived
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListPresentationShares — адресные ссылки презентации с per-лид статусами просмотров.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListPresentationShares: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceListPresentationShares', 'id', id)
      const localVarPath = `/api/v1/agents/me/presentations/{id}/shares`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListProjectMaterials — материалы доступного агенту ЖК (презентации/брошюры/прайсы/…); gate available_for_agents && visibility на стороне properties. Ссылки download_url presigned.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListProjectMaterials: async (
      residentialComplexId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'agentsServiceListProjectMaterials',
        'residentialComplexId',
        residentialComplexId,
      )
      const localVarPath = `/api/v1/agents/projects/{residentialComplexId}/materials`.replace(
        `{${'residentialComplexId'}}`,
        encodeURIComponent(String(residentialComplexId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary --- Админ-CRUD правил маршрутизации обращений (DEV-343). Permission agents:admin (проверка в хендлере requireAdmin). ---
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListRoutingRules: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/routing-rules`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary --- Веб-инбокс тикетов агентов (DEV-432). Authenticated; role-scoping в хендлере:     ADMIN/HOS/agents:manage — все тикеты; MANAGER — только свои (primary/backup/taken_by). ---
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [status] new|in_progress|closed
     * @param {string} [type]
     * @param {boolean} [assignedToMe] только где я ответственный/резерв/взял
     * @param {string} [agentUserId]
     * @param {string} [createdFrom] created_at &gt;&#x3D;
     * @param {string} [createdTo] created_at &lt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListTickets: async (
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      type?: string,
      assignedToMe?: boolean,
      agentUserId?: string,
      createdFrom?: string,
      createdTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/tickets`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      if (assignedToMe !== undefined) {
        localVarQueryParameter['assignedToMe'] = assignedToMe
      }

      if (agentUserId !== undefined) {
        localVarQueryParameter['agentUserId'] = agentUserId
      }

      if (createdFrom !== undefined) {
        localVarQueryParameter['createdFrom'] =
          (createdFrom as any) instanceof Date ? (createdFrom as any).toISOString() : createdFrom
      }

      if (createdTo !== undefined) {
        localVarQueryParameter['createdTo'] =
          (createdTo as any) instanceof Date ? (createdTo as any).toISOString() : createdTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListWebinars — обучающие вебинары + статус участия агента (DEV-489 §10, экран C8).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListWebinars: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/webinars`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} ticketId
     * @param {AgentsServicePostAgentTicketMessageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServicePostAgentTicketMessage: async (
      ticketId: string,
      body: AgentsServicePostAgentTicketMessageBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServicePostAgentTicketMessage', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServicePostAgentTicketMessage', 'body', body)
      const localVarPath = `/api/v1/agents/me/tickets/{ticketId}/messages`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary PublishOfferVersion — опубликовать редакцию текста оферты (DEV-616 / ADR-0022). Privileged (agents:manage). trigger_reacceptance=true переводит accepted-агентов с версией ниже в needs_reacceptance в той же транзакции.
     * @param {V1PublishOfferVersionRequest} body PublishOfferVersionRequest — публикация одной языковой редакции оферты (DEV-616 / ADR-0022). version общий для всех языков; язык отдельной записью. Документ — структурный (как GetOffer).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServicePublishOfferVersion: async (
      body: V1PublishOfferVersionRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServicePublishOfferVersion', 'body', body)
      const localVarPath = `/api/v1/agents/offer/publish`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Ошибки ввода отдаются как InvalidArgument (email занят — AlreadyExists) с деталями google.rpc.BadRequest: field = JSON-имя поля запроса, description = код причины (ADR-0031). Клиент подсвечивает поле и локализует текст по коду; плоский message — фолбэк. Реестр кодов (новый код заводится только вместе с i18n-ключом на клиентах):   INVALID_VALUE | INVALID_EMAIL | INVALID_PASSWORD | INVALID_PHONE | INVALID_COUNTRY   EMAIL_TAKEN | AGREEMENT_REQUIRED | CAPTCHA_FAILED | OFFER_VERSION_OUTDATED
     * @summary Register — публичный (gateway + капча Turnstile). Создаёт креду в auth (PENDING), профиль агента и запись принятия оферты. Логин — после подтверждения email.
     * @param {V1RegisterRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRegister: async (
      body: V1RegisterRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceRegister', 'body', body)
      const localVarPath = `/api/v1/agents/register`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary RegisterForWebinar — регистрация текущего агента на вебинар (роль AGENT).
     * @param {string} webinarId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRegisterForWebinar: async (
      webinarId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'webinarId' is not null or undefined
      assertParamExists('agentsServiceRegisterForWebinar', 'webinarId', webinarId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceRegisterForWebinar', 'body', body)
      const localVarPath = `/api/v1/agents/me/webinars/{webinarId}/register`.replace(
        `{${'webinarId'}}`,
        encodeURIComponent(String(webinarId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary --- Диалог по обращению (DEV-433). staff/agent — authenticated; *Internal — для бота (public). --- staff: ответ менеджера/РОПа в переписку (опц. взять в работу).
     * @param {string} ticketId
     * @param {AgentsServiceReplyTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceReplyTicket: async (
      ticketId: string,
      body: AgentsServiceReplyTicketBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServiceReplyTicket', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceReplyTicket', 'body', body)
      const localVarPath = `/api/v1/agents/tickets/{ticketId}/reply`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary RequestMeeting — DEV-347 «Назначить встречу». Создаёт обращение meeting_request по сделке агента (маршрутизация на менеджера сделки); детали — в payload.
     * @param {string} dealId из path
     * @param {AgentsServiceRequestMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRequestMeeting: async (
      dealId: string,
      body: AgentsServiceRequestMeetingBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceRequestMeeting', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceRequestMeeting', 'body', body)
      const localVarPath = `/api/v1/agents/deals/{dealId}/meeting`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary SearchPartnerCompanies — публичные подсказки компаний по префиксу имени для поля «Агентство» на форме регистрации агента (анонимно, DEV-1052). Возвращает минимум (id + имя + город), без чувствительных полей. Отдельный путь (не /companies/{id}, чтобы grpc-gateway не перехватывал подпуть /{id}).
     * @param {string} [query]
     * @param {number} [limit] 0 → дефолт 10
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSearchPartnerCompanies: async (
      query?: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/company-search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary SetAgentCommercialTerms — коммерческая модель агента (DEV-472, ТЗ §9): 30/50/спецусловия. Только privileged (agents:manage); approved_by спецусловий = вызывающий.
     * @param {string} userId
     * @param {AgentsServiceSetAgentCommercialTermsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentCommercialTerms: async (
      userId: string,
      body: AgentsServiceSetAgentCommercialTermsBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceSetAgentCommercialTerms', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSetAgentCommercialTerms', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/commercial-terms`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary SetAgentOfferStatus — перевод статуса оферты (DEV-472, ТЗ §9.1): sent/needs_reacceptance/ rejected/suspended/not_sent. accepted выставляется потоком принятия, не вручную. Privileged.
     * @param {string} userId
     * @param {AgentsServiceSetAgentOfferStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentOfferStatus: async (
      userId: string,
      body: AgentsServiceSetAgentOfferStatusBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceSetAgentOfferStatus', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSetAgentOfferStatus', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/offer-status`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary SetAgentStatus — смена жизненного статуса агента (DEV-780): активация («Одобрить», candidate/…→active), неактивность (dormant), архив (archived). Privileged (agents:manage). Ранние статусы (candidate/pending_offer/new_partner/onboarding) выставляются потоками регистрации/онбординга, не этим RPC. Блокировка/разблокировка (blocked) — отдельной задачей. POST на 3-сегментном пути не конфликтует с wildcard GET /agents/{user_id} (DEV-509).
     * @param {string} userId
     * @param {AgentsServiceSetAgentStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentStatus: async (
      userId: string,
      body: AgentsServiceSetAgentStatusBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceSetAgentStatus', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSetAgentStatus', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/status`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceSetRoutingRuleEnabledBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetRoutingRuleEnabled: async (
      id: string,
      body: AgentsServiceSetRoutingRuleEnabledBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceSetRoutingRuleEnabled', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSetRoutingRuleEnabled', 'body', body)
      const localVarPath = `/api/v1/agents/routing-rules/{id}/enabled`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary SharePresentation — адресная ссылка презентации для конкретного лида (DEV-1017). Идемпотентно: повторный шаринг тому же лиду возвращает существующую ссылку.
     * @param {string} id презентация (path)
     * @param {AgentsServiceSharePresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSharePresentation: async (
      id: string,
      body: AgentsServiceSharePresentationBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceSharePresentation', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSharePresentation', 'body', body)
      const localVarPath = `/api/v1/agents/me/presentations/{id}/shares`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary SubmitInquiry — DEV-348 «Свободный вопрос». Создаёт обращение из свободного текста для сценариев «Другой вопрос» (other) и «Изучение стратегий → задать вопрос» (strategy_question). Без сделки; маршрутизация по типу (role-based).
     * @param {V1SubmitInquiryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSubmitInquiry: async (
      body: V1SubmitInquiryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSubmitInquiry', 'body', body)
      const localVarPath = `/api/v1/agents/inquiries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary SubmitLead — отправка уведомления о клиенте (защищён, роль AGENT).
     * @param {V1SubmitLeadRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSubmitLead: async (
      body: V1SubmitLeadRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSubmitLead', 'body', body)
      const localVarPath = `/api/v1/agents/leads/submit`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTakeTicket: async (
      ticketId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServiceTakeTicket', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceTakeTicket', 'body', body)
      const localVarPath = `/api/v1/agents/tickets/{ticketId}/take`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTransferTicket: async (
      ticketId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServiceTransferTicket', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceTransferTicket', 'body', body)
      const localVarPath = `/api/v1/agents/tickets/{ticketId}/transfer`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateMyPresentation — сменить ЖК/язык/название/комментарий (re-snapshot + re-PDF; токен НЕ меняется — отправленная ссылка показывает обновлённую версию).
     * @param {string} id
     * @param {AgentsServiceUpdateMyPresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateMyPresentation: async (
      id: string,
      body: AgentsServiceUpdateMyPresentationBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceUpdateMyPresentation', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceUpdateMyPresentation', 'body', body)
      const localVarPath = `/api/v1/agents/me/presentations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateMyProfile — обновить свой профиль (страна/город) текущим агентом (DEV-606).
     * @param {V1UpdateMyProfileRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateMyProfile: async (
      body: V1UpdateMyProfileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceUpdateMyProfile', 'body', body)
      const localVarPath = `/api/v1/agents/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceUpdatePartnerCompanyBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdatePartnerCompany: async (
      id: string,
      body: AgentsServiceUpdatePartnerCompanyBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceUpdatePartnerCompany', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceUpdatePartnerCompany', 'body', body)
      const localVarPath = `/api/v1/agents/companies/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceUpdateRoutingRuleBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateRoutingRule: async (
      id: string,
      body: AgentsServiceUpdateRoutingRuleBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceUpdateRoutingRule', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceUpdateRoutingRule', 'body', body)
      const localVarPath = `/api/v1/agents/routing-rules/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AgentsServiceApi - functional programming interface
 * @export
 */
export const AgentsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AgentsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary ArchivePartnerCompany — архивирование (удаление запрещено, ТЗ §13.3). Системную «Частный агент» нельзя.
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceArchivePartnerCompany(
      id: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PartnerCompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceArchivePartnerCompany(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceArchivePartnerCompany']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary AskCommission — DEV-346 «Вопрос по вознаграждению». Есть дата выплаты — вернуть; иначе создать обращение commission_question (маршрутизация) и сигналить «дата уточняется».
     * @param {string} dealId из path
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceAskCommission(
      dealId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AskCommissionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceAskCommission(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceAskCommission']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetAgent (`GET /agents/{user_id}`) объявлен ВЫШЕ — перед GetMyProfile — из-за порядка матчинга grpc-gateway (см. комментарий там). НЕ переносить его сюда. (DEV-509)
     * @param {string} userId агент (из path)
     * @param {AgentsServiceAssignAgentManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceAssignAgentManager(
      userId: string,
      body: AgentsServiceAssignAgentManagerBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceAssignAgentManager(
        userId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceAssignAgentManager']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CheckLeadUnique — проверка телефона клиента (защищён, роль AGENT). Данные найденного клиента не раскрываются (§16).
     * @param {V1CheckLeadUniqueRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCheckLeadUnique(
      body: V1CheckLeadUniqueRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CheckLeadUniqueResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCheckLeadUnique(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCheckLeadUnique']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} ticketId
     * @param {AgentsServiceCloseTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCloseTicket(
      ticketId: string,
      body: AgentsServiceCloseTicketBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1TicketActionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCloseTicket(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCloseTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} userId
     * @param {string} taskId
     * @param {AgentsServiceCompleteAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCompleteAgentTask(
      userId: string,
      taskId: string,
      body: AgentsServiceCompleteAgentTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentTask>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCompleteAgentTask(
        userId,
        taskId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCompleteAgentTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {V1ConfirmCompanyAssignmentByAgentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceConfirmCompanyAssignmentByAgent(
      body: V1ConfirmCompanyAssignmentByAgentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CompanyVerificationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceConfirmCompanyAssignmentByAgent(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceConfirmCompanyAssignmentByAgent']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceConfirmCompanyAssignmentByManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceConfirmCompanyAssignmentByManager(
      id: string,
      body: AgentsServiceConfirmCompanyAssignmentByManagerBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CompanyVerificationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceConfirmCompanyAssignmentByManager(
          id,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceConfirmCompanyAssignmentByManager']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateAgent — ручное создание агента менеджером (DEV-470, ADR-0016): заводит PENDING-креду в auth + профиль (created_mode=manual, status=candidate). Дедуп по phone/email/telegram. Права: ADMIN/HOS/agents:manage (requireAgentsManager + privileged).
     * @param {V1CreateAgentRequest} body -------------------- Ручное создание агента (DEV-470) -------------------- Менеджер заводит агента до его входа в панель. email обязателен (PENDING-креда в auth); company_id обязателен (ТЗ §6 — компания обязательна; для одиночки — UUID «Частный агент»).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateAgent(
      body: V1CreateAgentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateAgent(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateAgent']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} userId агент (из path)
     * @param {AgentsServiceCreateAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateAgentTask(
      userId: string,
      body: AgentsServiceCreateAgentTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentTask>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateAgentTask(
        userId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateAgentTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateClientComment — комментарий агента по СВОЕМУ клиенту (уведомляет ответственного менеджера).
     * @param {string} clientId из path
     * @param {AgentsServiceCreateClientCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateClientComment(
      clientId: string,
      body: AgentsServiceCreateClientCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentClientComment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateClientComment(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateClientComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateDealComment — комментарий агента по СВОЕЙ сделке (уведомляет менеджера сделки).
     * @param {string} dealId из path
     * @param {AgentsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateDealComment(
      dealId: string,
      body: AgentsServiceCreateDealCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentDealComment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateDealComment(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateDealComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateDealTask — задача агента по СВОЕЙ сделке на свободный слот менеджера (409 AlreadyExists, если слот занят). Уведомляет менеджера сделки.
     * @param {string} dealId из path
     * @param {AgentsServiceCreateDealTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateDealTask(
      dealId: string,
      body: AgentsServiceCreateDealTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentDealTask>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateDealTask(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateDealTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateMyPresentation — собрать презентацию по выбранному ЖК (снапшот + токен; PDF генерится асинхронно). Одна презентация = один ЖК.
     * @param {V1CreateMyPresentationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateMyPresentation(
      body: V1CreateMyPresentationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentPresentation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateMyPresentation(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateMyPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary --- Компании-партнёры (DEV-469, ТЗ §5). Authenticated; права в хендлере:     чтение — ADMIN/HOS/agents:manage/MANAGER; запись — ADMIN/HOS/agents:manage. ---
     * @param {V1CreatePartnerCompanyRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreatePartnerCompany(
      body: V1CreatePartnerCompanyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PartnerCompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreatePartnerCompany(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreatePartnerCompany']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {V1CreateRoutingRuleRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateRoutingRule(
      body: V1CreateRoutingRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RoutingRuleResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateRoutingRule(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateRoutingRule']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateWebinar — публикация вебинара штатом (DEV-489). Permission agents:manage (ADMIN/HOS) на интерцепторе.
     * @param {V1CreateWebinarRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateWebinar(
      body: V1CreateWebinarRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Webinar>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateWebinar(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateWebinar']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeleteAgentBotLink — отвязать Telegram-бот текущего агента (защищён, роль AGENT). Проксирует agent-bot.UnlinkAgentBinding (DEV-642).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceDeleteAgentBotLink(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DeleteAgentBotLinkResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceDeleteAgentBotLink(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceDeleteAgentBotLink']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeleteMyPresentation — мягкое удаление (лендинг по токену → 404).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceDeleteMyPresentation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceDeleteMyPresentation(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceDeleteMyPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceDeleteRoutingRule(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceDeleteRoutingRule(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceDeleteRoutingRule']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ВНИМАНИЕ, ПОРЯДОК (grpc-gateway): catch-all `GET /agents/{user_id}` (GetAgent) ДОЛЖЕН быть объявлен ПЕРВЫМ среди GET-методов. runtime.ServeMux.Handle делает prepend, поэтому later-registered маршрут матчится РАНЬШЕ, а специфичность/литералы НЕ приоритизируются. Объявив wildcard первым, кладём его в конец цепочки матчинга → статические `/agents/<literal>` (me, routing-rules, tickets, companies) перехватывают раньше него. НЕ добавлять статические GET-маршруты /agents/_* ВЫШЕ этого rpc. (DEV-509)
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgent(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetAgent(
        userId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgent']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetAgentBotLinkCode — одноразовый код привязки Telegram-бота + deep-link (защищён, роль AGENT). Для «Подключить бота» в агентской панели (DEV-341/353).
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentBotLinkCode(
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentBotLinkCodeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetAgentBotLinkCode(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentBotLinkCode']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetAgentBotStatus — статус привязки Telegram-бота агента (защищён, роль AGENT). Проксирует agent-bot.GetAgentBinding — единый источник правды по привязке (DEV-642 / ADR-0023). ВАЖНО (DEV-509): статический GET /agents/me/bot-status объявлен НИЖЕ GetAgent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentBotStatus(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentBotStatusResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceGetAgentBotStatus(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentBotStatus']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetAgentDashboard — KPI кабинета агента (DEV-489): передано клиентов, активные сделки, депозиты, прогноз вознаграждения, последняя активность, ближайшая задача.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentDashboard(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentDashboardResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceGetAgentDashboard(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentDashboard']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetAgentDeals — сделки агента для карточки штата (DEV-780): реальные имена клиентов (в отличие от кабинета агента, где маскируются) + агрегаты вознаграждения (начислено/к выплате). Штат-скоуп в хендлере (MANAGER — свои подопечные, ADMIN/HOS — все). Данные — из deals-service (per-deal reward-поля; «история» пока там же). ВАЖНО (класс DEV-509): wildcard GET /agents/{user_id}/deals объявлен ВЫШЕ статического /agents/me/deals (ListMyDeals) той же длины — иначе later-registered wildcard перехватывает /me/deals (prepend-матчинг grpc-gateway, литералы не приоритизируются) → 403 agents:read вместо кабинета агента. НЕ опускать ниже ListMyDeals.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentDeals(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentDealsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetAgentDeals(
        userId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentDeals']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetCompanyVerification(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CompanyVerificationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetCompanyVerification(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetCompanyVerification']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetDealFreeSlots — свободные слоты менеджера СВОЕЙ сделки (запись задачи/встречи). from/to опц.
     * @param {string} dealId
     * @param {string} [from] опц. начало окна (query, RFC3339)
     * @param {string} [to] опц. конец окна (query, RFC3339)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetDealFreeSlots(
      dealId: string,
      from?: string,
      to?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealFreeSlotsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetDealFreeSlots(
        dealId,
        from,
        to,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetDealFreeSlots']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary --- Верификация компании агента (DEV-791, RFC §9). --- Agent-facing (роль AGENT, только своё; requireAgent в хендлере): просмотр кандидатов и выбор.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetMyCompanyVerification(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CompanyVerificationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceGetMyCompanyVerification(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetMyCompanyVerification']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetMyPresentation — карточка презентации (владелец).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetMyPresentation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentPresentation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetMyPresentation(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetMyPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetMyProfile — профиль текущего агента (защищён, роль AGENT).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetMyProfile(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetMyProfile(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetMyProfile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetMyTicket(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetTicketResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetMyTicket(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetMyTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetOffer — публичная актуальная (или конкретная по version) редакция оферты. Язык — через user-locale (заголовок). Без токена, как Register. DEV-616 / ADR-0022. ВАЖНО (DEV-509/DEV-638): объявлен НИЖЕ GetAgent — статический GET /agents/offer иначе перехватывается wildcard GET /agents/{user_id} (grpc-gateway prepend) → 403 agents:read.
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetOffer(
      version?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1OfferDocument>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetOffer(
        version,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetOffer']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetPartnerCompany(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PartnerCompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetPartnerCompany(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetPartnerCompany']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetPublicPresentation — публичный резолв по токену для лендинга vinprop.vn/p/{token} (без auth). Трекает просмотр (view_count++, событие presentation.viewed).
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetPublicPresentation(
      token: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PublicPresentationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetPublicPresentation(
        token,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetPublicPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetStaffBotLinkCode — код привязки сотрудника к agency-боту для уведомлений (authenticated, DEV-344).
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetStaffBotLinkCode(
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentBotLinkCodeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetStaffBotLinkCode(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetStaffBotLinkCode']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetTicket(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetTicketResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetTicket(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary --- Задачи агента (DEV-511, владелец agent_tasks; зеркало deals Task). Authenticated;     скоуп «свои/все» по роли в хендлере. Чтение — agents:read, запись — agents:update.     Маршруты 3-сегментные (/{user_id}/tasks...) не конфликтуют с wildcard GetAgent (DEV-509). ---
     * @param {string} userId
     * @param {string} [statusFilter] open | done | \&quot;\&quot; (все). Фильтр в service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListAgentTasks(
      userId: string,
      statusFilter?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListAgentTasksResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListAgentTasks(
        userId,
        statusFilter,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListAgentTasks']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary --- Управление агентами + назначение куратора (DEV-430). Authenticated; права в хендлере:     ADMIN/HOS/agents:manage — любого агента/менеджера; MANAGER — только себя («взять агента»). ---
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [searchQuery] FTS по full_name (PostgreSQL to_tsvector), не LIKE.
     * @param {string} [managerId] Фильтр по куратору (user_id менеджера); \&quot;\&quot; игнорируется. Не-привилегированному принудительно выставляется &#x3D; себе (см. хендлер requireAgentsManager).
     * @param {string} [country]
     * @param {string} [language]
     * @param {string} [agentStatus] Структурные фильтры реестра (DEV-471, ТЗ §4.3); \&quot;\&quot; игнорируется.
     * @param {string} [companyId]
     * @param {string} [companyAssignmentStatus] requires_verification &#x3D; «компания не подтверждена»
     * @param {string} [sourceGroup]
     * @param {string} [registeredFrom] created_at &gt;&#x3D;
     * @param {string} [registeredTo] created_at &lt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListAgents(
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      managerId?: string,
      country?: string,
      language?: string,
      agentStatus?: string,
      companyId?: string,
      companyAssignmentStatus?: string,
      sourceGroup?: string,
      registeredFrom?: string,
      registeredTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListAgentsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListAgents(
        paginationPage,
        paginationPerPage,
        searchQuery,
        managerId,
        country,
        language,
        agentStatus,
        companyId,
        companyAssignmentStatus,
        sourceGroup,
        registeredFrom,
        registeredTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListAgents']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListClientComments — комментарии агента по СВОЕМУ клиенту (агент видит только свои).
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListClientComments(
      clientId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClientCommentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListClientComments(
        clientId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListClientComments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Manager-facing (пермишены на интерцепторе: очередь — agents:read, приём — agents:manage).
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [verificationStatus] \&quot;\&quot; → manager_review
     * @param {string} [responsibleId]
     * @param {string} [agentUserId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListCompanyVerifications(
      paginationPage?: string,
      paginationPerPage?: string,
      verificationStatus?: string,
      responsibleId?: string,
      agentUserId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListCompanyVerificationsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceListCompanyVerifications(
          paginationPage,
          paginationPerPage,
          verificationStatus,
          responsibleId,
          agentUserId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListCompanyVerifications']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListDealComments — комментарии агента по СВОЕЙ сделке (агент видит только свои).
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListDealComments(
      dealId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealCommentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListDealComments(
        dealId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListDealComments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListMyClients — переданные агентом клиенты (agent_id из контекста, DEV-489 §11). Public-safe: маскированное имя, источник, публичный статус клиента; без телефона, внутренних комментариев и чужих клиентов.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyClients(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListMyClientsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListMyClients(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyClients']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListMyDeals — сделки текущего агента (agent_id из контекста). Имя клиента маскируется («Иван П.»). Для «Мои сделки» и сценариев вознаграждения/встречи (DEV-350, DEV-332).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyDeals(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListMyDealsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListMyDeals(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyDeals']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListMyPresentations — список презентаций текущего агента.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyPresentations(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListMyPresentationsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceListMyPresentations(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyPresentations']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListMyReferrals — контакты СВОИХ переданных лидов для «Поделиться» презентацией (DEV-1016). Источник — собственные сабмишены агента; §11: canonical client-data не раскрываем. Authenticated + requireAgent (только свои лиды).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyReferrals(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListMyReferralsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceListMyReferrals(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyReferrals']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary agent (роль AGENT): свои обращения + переписка.
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyTickets(
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListTicketsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListMyTickets(
        paginationPage,
        paginationPerPage,
        status,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyTickets']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [searchQuery] FTS по company_name
     * @param {string} [companyStatus]
     * @param {string} [companyType]
     * @param {string} [responsiblePartnerManagerId]
     * @param {boolean} [includeArchived]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListPartnerCompanies(
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      companyStatus?: string,
      companyType?: string,
      responsiblePartnerManagerId?: string,
      includeArchived?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListPartnerCompaniesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListPartnerCompanies(
        paginationPage,
        paginationPerPage,
        searchQuery,
        companyStatus,
        companyType,
        responsiblePartnerManagerId,
        includeArchived,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListPartnerCompanies']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListPresentationShares — адресные ссылки презентации с per-лид статусами просмотров.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListPresentationShares(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListPresentationSharesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListPresentationShares(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListPresentationShares']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListProjectMaterials — материалы доступного агенту ЖК (презентации/брошюры/прайсы/…); gate available_for_agents && visibility на стороне properties. Ссылки download_url presigned.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListProjectMaterials(
      residentialComplexId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListProjectMaterialsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListProjectMaterials(
        residentialComplexId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListProjectMaterials']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary --- Админ-CRUD правил маршрутизации обращений (DEV-343). Permission agents:admin (проверка в хендлере requireAdmin). ---
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListRoutingRules(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListRoutingRulesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceListRoutingRules(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListRoutingRules']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary --- Веб-инбокс тикетов агентов (DEV-432). Authenticated; role-scoping в хендлере:     ADMIN/HOS/agents:manage — все тикеты; MANAGER — только свои (primary/backup/taken_by). ---
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [status] new|in_progress|closed
     * @param {string} [type]
     * @param {boolean} [assignedToMe] только где я ответственный/резерв/взял
     * @param {string} [agentUserId]
     * @param {string} [createdFrom] created_at &gt;&#x3D;
     * @param {string} [createdTo] created_at &lt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListTickets(
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      type?: string,
      assignedToMe?: boolean,
      agentUserId?: string,
      createdFrom?: string,
      createdTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListTicketsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListTickets(
        paginationPage,
        paginationPerPage,
        status,
        type,
        assignedToMe,
        agentUserId,
        createdFrom,
        createdTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListTickets']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListWebinars — обучающие вебинары + статус участия агента (DEV-489 §10, экран C8).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListWebinars(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListWebinarsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListWebinars(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListWebinars']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} ticketId
     * @param {AgentsServicePostAgentTicketMessageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServicePostAgentTicketMessage(
      ticketId: string,
      body: AgentsServicePostAgentTicketMessageBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PostAgentTicketMessageResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServicePostAgentTicketMessage(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServicePostAgentTicketMessage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary PublishOfferVersion — опубликовать редакцию текста оферты (DEV-616 / ADR-0022). Privileged (agents:manage). trigger_reacceptance=true переводит accepted-агентов с версией ниже в needs_reacceptance в той же транзакции.
     * @param {V1PublishOfferVersionRequest} body PublishOfferVersionRequest — публикация одной языковой редакции оферты (DEV-616 / ADR-0022). version общий для всех языков; язык отдельной записью. Документ — структурный (как GetOffer).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServicePublishOfferVersion(
      body: V1PublishOfferVersionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PublishOfferVersionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServicePublishOfferVersion(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServicePublishOfferVersion']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Ошибки ввода отдаются как InvalidArgument (email занят — AlreadyExists) с деталями google.rpc.BadRequest: field = JSON-имя поля запроса, description = код причины (ADR-0031). Клиент подсвечивает поле и локализует текст по коду; плоский message — фолбэк. Реестр кодов (новый код заводится только вместе с i18n-ключом на клиентах):   INVALID_VALUE | INVALID_EMAIL | INVALID_PASSWORD | INVALID_PHONE | INVALID_COUNTRY   EMAIL_TAKEN | AGREEMENT_REQUIRED | CAPTCHA_FAILED | OFFER_VERSION_OUTDATED
     * @summary Register — публичный (gateway + капча Turnstile). Создаёт креду в auth (PENDING), профиль агента и запись принятия оферты. Логин — после подтверждения email.
     * @param {V1RegisterRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceRegister(
      body: V1RegisterRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RegisterResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceRegister(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceRegister']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary RegisterForWebinar — регистрация текущего агента на вебинар (роль AGENT).
     * @param {string} webinarId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceRegisterForWebinar(
      webinarId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RegisterForWebinarResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceRegisterForWebinar(
        webinarId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceRegisterForWebinar']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary --- Диалог по обращению (DEV-433). staff/agent — authenticated; *Internal — для бота (public). --- staff: ответ менеджера/РОПа в переписку (опц. взять в работу).
     * @param {string} ticketId
     * @param {AgentsServiceReplyTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceReplyTicket(
      ticketId: string,
      body: AgentsServiceReplyTicketBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ReplyTicketResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceReplyTicket(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceReplyTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary RequestMeeting — DEV-347 «Назначить встречу». Создаёт обращение meeting_request по сделке агента (маршрутизация на менеджера сделки); детали — в payload.
     * @param {string} dealId из path
     * @param {AgentsServiceRequestMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceRequestMeeting(
      dealId: string,
      body: AgentsServiceRequestMeetingBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RequestMeetingResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceRequestMeeting(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceRequestMeeting']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary SearchPartnerCompanies — публичные подсказки компаний по префиксу имени для поля «Агентство» на форме регистрации агента (анонимно, DEV-1052). Возвращает минимум (id + имя + город), без чувствительных полей. Отдельный путь (не /companies/{id}, чтобы grpc-gateway не перехватывал подпуть /{id}).
     * @param {string} [query]
     * @param {number} [limit] 0 → дефолт 10
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSearchPartnerCompanies(
      query?: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SearchPartnerCompaniesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSearchPartnerCompanies(
        query,
        limit,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSearchPartnerCompanies']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary SetAgentCommercialTerms — коммерческая модель агента (DEV-472, ТЗ §9): 30/50/спецусловия. Только privileged (agents:manage); approved_by спецусловий = вызывающий.
     * @param {string} userId
     * @param {AgentsServiceSetAgentCommercialTermsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSetAgentCommercialTerms(
      userId: string,
      body: AgentsServiceSetAgentCommercialTermsBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceSetAgentCommercialTerms(userId, body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSetAgentCommercialTerms']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary SetAgentOfferStatus — перевод статуса оферты (DEV-472, ТЗ §9.1): sent/needs_reacceptance/ rejected/suspended/not_sent. accepted выставляется потоком принятия, не вручную. Privileged.
     * @param {string} userId
     * @param {AgentsServiceSetAgentOfferStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSetAgentOfferStatus(
      userId: string,
      body: AgentsServiceSetAgentOfferStatusBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSetAgentOfferStatus(
        userId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSetAgentOfferStatus']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary SetAgentStatus — смена жизненного статуса агента (DEV-780): активация («Одобрить», candidate/…→active), неактивность (dormant), архив (archived). Privileged (agents:manage). Ранние статусы (candidate/pending_offer/new_partner/onboarding) выставляются потоками регистрации/онбординга, не этим RPC. Блокировка/разблокировка (blocked) — отдельной задачей. POST на 3-сегментном пути не конфликтует с wildcard GET /agents/{user_id} (DEV-509).
     * @param {string} userId
     * @param {AgentsServiceSetAgentStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSetAgentStatus(
      userId: string,
      body: AgentsServiceSetAgentStatusBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSetAgentStatus(
        userId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSetAgentStatus']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceSetRoutingRuleEnabledBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSetRoutingRuleEnabled(
      id: string,
      body: AgentsServiceSetRoutingRuleEnabledBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RoutingRuleResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSetRoutingRuleEnabled(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSetRoutingRuleEnabled']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary SharePresentation — адресная ссылка презентации для конкретного лида (DEV-1017). Идемпотентно: повторный шаринг тому же лиду возвращает существующую ссылку.
     * @param {string} id презентация (path)
     * @param {AgentsServiceSharePresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSharePresentation(
      id: string,
      body: AgentsServiceSharePresentationBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PresentationShare>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSharePresentation(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSharePresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary SubmitInquiry — DEV-348 «Свободный вопрос». Создаёт обращение из свободного текста для сценариев «Другой вопрос» (other) и «Изучение стратегий → задать вопрос» (strategy_question). Без сделки; маршрутизация по типу (role-based).
     * @param {V1SubmitInquiryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSubmitInquiry(
      body: V1SubmitInquiryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SubmitInquiryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSubmitInquiry(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSubmitInquiry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary SubmitLead — отправка уведомления о клиенте (защищён, роль AGENT).
     * @param {V1SubmitLeadRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSubmitLead(
      body: V1SubmitLeadRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SubmitLeadResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSubmitLead(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSubmitLead']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceTakeTicket(
      ticketId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1TicketActionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceTakeTicket(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceTakeTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceTransferTicket(
      ticketId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1TicketActionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceTransferTicket(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceTransferTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateMyPresentation — сменить ЖК/язык/название/комментарий (re-snapshot + re-PDF; токен НЕ меняется — отправленная ссылка показывает обновлённую версию).
     * @param {string} id
     * @param {AgentsServiceUpdateMyPresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceUpdateMyPresentation(
      id: string,
      body: AgentsServiceUpdateMyPresentationBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentPresentation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceUpdateMyPresentation(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceUpdateMyPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateMyProfile — обновить свой профиль (страна/город) текущим агентом (DEV-606).
     * @param {V1UpdateMyProfileRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceUpdateMyProfile(
      body: V1UpdateMyProfileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceUpdateMyProfile(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceUpdateMyProfile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceUpdatePartnerCompanyBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceUpdatePartnerCompany(
      id: string,
      body: AgentsServiceUpdatePartnerCompanyBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PartnerCompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceUpdatePartnerCompany(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceUpdatePartnerCompany']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceUpdateRoutingRuleBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceUpdateRoutingRule(
      id: string,
      body: AgentsServiceUpdateRoutingRuleBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RoutingRuleResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceUpdateRoutingRule(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceUpdateRoutingRule']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AgentsServiceApi - factory interface
 * @export
 */
export const AgentsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AgentsServiceApiFp(configuration)
  return {
    /**
     *
     * @summary ArchivePartnerCompany — архивирование (удаление запрещено, ТЗ §13.3). Системную «Частный агент» нельзя.
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceArchivePartnerCompany(
      id: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1PartnerCompanyResponse> {
      return localVarFp
        .agentsServiceArchivePartnerCompany(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary AskCommission — DEV-346 «Вопрос по вознаграждению». Есть дата выплаты — вернуть; иначе создать обращение commission_question (маршрутизация) и сигналить «дата уточняется».
     * @param {string} dealId из path
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceAskCommission(
      dealId: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1AskCommissionResponse> {
      return localVarFp
        .agentsServiceAskCommission(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetAgent (`GET /agents/{user_id}`) объявлен ВЫШЕ — перед GetMyProfile — из-за порядка матчинга grpc-gateway (см. комментарий там). НЕ переносить его сюда. (DEV-509)
     * @param {string} userId агент (из path)
     * @param {AgentsServiceAssignAgentManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceAssignAgentManager(
      userId: string,
      body: AgentsServiceAssignAgentManagerBody,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceAssignAgentManager(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CheckLeadUnique — проверка телефона клиента (защищён, роль AGENT). Данные найденного клиента не раскрываются (§16).
     * @param {V1CheckLeadUniqueRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCheckLeadUnique(
      body: V1CheckLeadUniqueRequest,
      options?: any,
    ): AxiosPromise<V1CheckLeadUniqueResponse> {
      return localVarFp
        .agentsServiceCheckLeadUnique(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} ticketId
     * @param {AgentsServiceCloseTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCloseTicket(
      ticketId: string,
      body: AgentsServiceCloseTicketBody,
      options?: any,
    ): AxiosPromise<V1TicketActionResponse> {
      return localVarFp
        .agentsServiceCloseTicket(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} userId
     * @param {string} taskId
     * @param {AgentsServiceCompleteAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCompleteAgentTask(
      userId: string,
      taskId: string,
      body: AgentsServiceCompleteAgentTaskBody,
      options?: any,
    ): AxiosPromise<V1AgentTask> {
      return localVarFp
        .agentsServiceCompleteAgentTask(userId, taskId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {V1ConfirmCompanyAssignmentByAgentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceConfirmCompanyAssignmentByAgent(
      body: V1ConfirmCompanyAssignmentByAgentRequest,
      options?: any,
    ): AxiosPromise<V1CompanyVerificationResponse> {
      return localVarFp
        .agentsServiceConfirmCompanyAssignmentByAgent(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceConfirmCompanyAssignmentByManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceConfirmCompanyAssignmentByManager(
      id: string,
      body: AgentsServiceConfirmCompanyAssignmentByManagerBody,
      options?: any,
    ): AxiosPromise<V1CompanyVerificationResponse> {
      return localVarFp
        .agentsServiceConfirmCompanyAssignmentByManager(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateAgent — ручное создание агента менеджером (DEV-470, ADR-0016): заводит PENDING-креду в auth + профиль (created_mode=manual, status=candidate). Дедуп по phone/email/telegram. Права: ADMIN/HOS/agents:manage (requireAgentsManager + privileged).
     * @param {V1CreateAgentRequest} body -------------------- Ручное создание агента (DEV-470) -------------------- Менеджер заводит агента до его входа в панель. email обязателен (PENDING-креда в auth); company_id обязателен (ТЗ §6 — компания обязательна; для одиночки — UUID «Частный агент»).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateAgent(
      body: V1CreateAgentRequest,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceCreateAgent(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} userId агент (из path)
     * @param {AgentsServiceCreateAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateAgentTask(
      userId: string,
      body: AgentsServiceCreateAgentTaskBody,
      options?: any,
    ): AxiosPromise<V1AgentTask> {
      return localVarFp
        .agentsServiceCreateAgentTask(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateClientComment — комментарий агента по СВОЕМУ клиенту (уведомляет ответственного менеджера).
     * @param {string} clientId из path
     * @param {AgentsServiceCreateClientCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateClientComment(
      clientId: string,
      body: AgentsServiceCreateClientCommentBody,
      options?: any,
    ): AxiosPromise<V1AgentClientComment> {
      return localVarFp
        .agentsServiceCreateClientComment(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateDealComment — комментарий агента по СВОЕЙ сделке (уведомляет менеджера сделки).
     * @param {string} dealId из path
     * @param {AgentsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateDealComment(
      dealId: string,
      body: AgentsServiceCreateDealCommentBody,
      options?: any,
    ): AxiosPromise<V1AgentDealComment> {
      return localVarFp
        .agentsServiceCreateDealComment(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateDealTask — задача агента по СВОЕЙ сделке на свободный слот менеджера (409 AlreadyExists, если слот занят). Уведомляет менеджера сделки.
     * @param {string} dealId из path
     * @param {AgentsServiceCreateDealTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateDealTask(
      dealId: string,
      body: AgentsServiceCreateDealTaskBody,
      options?: any,
    ): AxiosPromise<V1AgentDealTask> {
      return localVarFp
        .agentsServiceCreateDealTask(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateMyPresentation — собрать презентацию по выбранному ЖК (снапшот + токен; PDF генерится асинхронно). Одна презентация = один ЖК.
     * @param {V1CreateMyPresentationRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateMyPresentation(
      body: V1CreateMyPresentationRequest,
      options?: any,
    ): AxiosPromise<V1AgentPresentation> {
      return localVarFp
        .agentsServiceCreateMyPresentation(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary --- Компании-партнёры (DEV-469, ТЗ §5). Authenticated; права в хендлере:     чтение — ADMIN/HOS/agents:manage/MANAGER; запись — ADMIN/HOS/agents:manage. ---
     * @param {V1CreatePartnerCompanyRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreatePartnerCompany(
      body: V1CreatePartnerCompanyRequest,
      options?: any,
    ): AxiosPromise<V1PartnerCompanyResponse> {
      return localVarFp
        .agentsServiceCreatePartnerCompany(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {V1CreateRoutingRuleRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateRoutingRule(
      body: V1CreateRoutingRuleRequest,
      options?: any,
    ): AxiosPromise<V1RoutingRuleResponse> {
      return localVarFp
        .agentsServiceCreateRoutingRule(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateWebinar — публикация вебинара штатом (DEV-489). Permission agents:manage (ADMIN/HOS) на интерцепторе.
     * @param {V1CreateWebinarRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateWebinar(
      body: V1CreateWebinarRequest,
      options?: any,
    ): AxiosPromise<V1Webinar> {
      return localVarFp
        .agentsServiceCreateWebinar(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeleteAgentBotLink — отвязать Telegram-бот текущего агента (защищён, роль AGENT). Проксирует agent-bot.UnlinkAgentBinding (DEV-642).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteAgentBotLink(options?: any): AxiosPromise<V1DeleteAgentBotLinkResponse> {
      return localVarFp
        .agentsServiceDeleteAgentBotLink(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeleteMyPresentation — мягкое удаление (лендинг по токену → 404).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteMyPresentation(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .agentsServiceDeleteMyPresentation(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteRoutingRule(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .agentsServiceDeleteRoutingRule(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ВНИМАНИЕ, ПОРЯДОК (grpc-gateway): catch-all `GET /agents/{user_id}` (GetAgent) ДОЛЖЕН быть объявлен ПЕРВЫМ среди GET-методов. runtime.ServeMux.Handle делает prepend, поэтому later-registered маршрут матчится РАНЬШЕ, а специфичность/литералы НЕ приоритизируются. Объявив wildcard первым, кладём его в конец цепочки матчинга → статические `/agents/<literal>` (me, routing-rules, tickets, companies) перехватывают раньше него. НЕ добавлять статические GET-маршруты /agents/_* ВЫШЕ этого rpc. (DEV-509)
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgent(userId: string, options?: any): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceGetAgent(userId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetAgentBotLinkCode — одноразовый код привязки Telegram-бота + deep-link (защищён, роль AGENT). Для «Подключить бота» в агентской панели (DEV-341/353).
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentBotLinkCode(
      body: object,
      options?: any,
    ): AxiosPromise<V1GetAgentBotLinkCodeResponse> {
      return localVarFp
        .agentsServiceGetAgentBotLinkCode(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetAgentBotStatus — статус привязки Telegram-бота агента (защищён, роль AGENT). Проксирует agent-bot.GetAgentBinding — единый источник правды по привязке (DEV-642 / ADR-0023). ВАЖНО (DEV-509): статический GET /agents/me/bot-status объявлен НИЖЕ GetAgent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentBotStatus(options?: any): AxiosPromise<V1GetAgentBotStatusResponse> {
      return localVarFp
        .agentsServiceGetAgentBotStatus(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetAgentDashboard — KPI кабинета агента (DEV-489): передано клиентов, активные сделки, депозиты, прогноз вознаграждения, последняя активность, ближайшая задача.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentDashboard(options?: any): AxiosPromise<V1GetAgentDashboardResponse> {
      return localVarFp
        .agentsServiceGetAgentDashboard(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetAgentDeals — сделки агента для карточки штата (DEV-780): реальные имена клиентов (в отличие от кабинета агента, где маскируются) + агрегаты вознаграждения (начислено/к выплате). Штат-скоуп в хендлере (MANAGER — свои подопечные, ADMIN/HOS — все). Данные — из deals-service (per-deal reward-поля; «история» пока там же). ВАЖНО (класс DEV-509): wildcard GET /agents/{user_id}/deals объявлен ВЫШЕ статического /agents/me/deals (ListMyDeals) той же длины — иначе later-registered wildcard перехватывает /me/deals (prepend-матчинг grpc-gateway, литералы не приоритизируются) → 403 agents:read вместо кабинета агента. НЕ опускать ниже ListMyDeals.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentDeals(
      userId: string,
      options?: any,
    ): AxiosPromise<V1GetAgentDealsResponse> {
      return localVarFp
        .agentsServiceGetAgentDeals(userId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetCompanyVerification(
      id: string,
      options?: any,
    ): AxiosPromise<V1CompanyVerificationResponse> {
      return localVarFp
        .agentsServiceGetCompanyVerification(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetDealFreeSlots — свободные слоты менеджера СВОЕЙ сделки (запись задачи/встречи). from/to опц.
     * @param {string} dealId
     * @param {string} [from] опц. начало окна (query, RFC3339)
     * @param {string} [to] опц. конец окна (query, RFC3339)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetDealFreeSlots(
      dealId: string,
      from?: string,
      to?: string,
      options?: any,
    ): AxiosPromise<V1GetDealFreeSlotsResponse> {
      return localVarFp
        .agentsServiceGetDealFreeSlots(dealId, from, to, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary --- Верификация компании агента (DEV-791, RFC §9). --- Agent-facing (роль AGENT, только своё; requireAgent в хендлере): просмотр кандидатов и выбор.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyCompanyVerification(
      options?: any,
    ): AxiosPromise<V1CompanyVerificationResponse> {
      return localVarFp
        .agentsServiceGetMyCompanyVerification(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetMyPresentation — карточка презентации (владелец).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyPresentation(id: string, options?: any): AxiosPromise<V1AgentPresentation> {
      return localVarFp
        .agentsServiceGetMyPresentation(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetMyProfile — профиль текущего агента (защищён, роль AGENT).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyProfile(options?: any): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceGetMyProfile(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyTicket(id: string, options?: any): AxiosPromise<V1GetTicketResponse> {
      return localVarFp
        .agentsServiceGetMyTicket(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetOffer — публичная актуальная (или конкретная по version) редакция оферты. Язык — через user-locale (заголовок). Без токена, как Register. DEV-616 / ADR-0022. ВАЖНО (DEV-509/DEV-638): объявлен НИЖЕ GetAgent — статический GET /agents/offer иначе перехватывается wildcard GET /agents/{user_id} (grpc-gateway prepend) → 403 agents:read.
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetOffer(version?: number, options?: any): AxiosPromise<V1OfferDocument> {
      return localVarFp
        .agentsServiceGetOffer(version, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetPartnerCompany(
      id: string,
      options?: any,
    ): AxiosPromise<V1PartnerCompanyResponse> {
      return localVarFp
        .agentsServiceGetPartnerCompany(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetPublicPresentation — публичный резолв по токену для лендинга vinprop.vn/p/{token} (без auth). Трекает просмотр (view_count++, событие presentation.viewed).
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetPublicPresentation(
      token: string,
      options?: any,
    ): AxiosPromise<V1PublicPresentationResponse> {
      return localVarFp
        .agentsServiceGetPublicPresentation(token, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetStaffBotLinkCode — код привязки сотрудника к agency-боту для уведомлений (authenticated, DEV-344).
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetStaffBotLinkCode(
      body: object,
      options?: any,
    ): AxiosPromise<V1GetAgentBotLinkCodeResponse> {
      return localVarFp
        .agentsServiceGetStaffBotLinkCode(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetTicket(id: string, options?: any): AxiosPromise<V1GetTicketResponse> {
      return localVarFp
        .agentsServiceGetTicket(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary --- Задачи агента (DEV-511, владелец agent_tasks; зеркало deals Task). Authenticated;     скоуп «свои/все» по роли в хендлере. Чтение — agents:read, запись — agents:update.     Маршруты 3-сегментные (/{user_id}/tasks...) не конфликтуют с wildcard GetAgent (DEV-509). ---
     * @param {string} userId
     * @param {string} [statusFilter] open | done | \&quot;\&quot; (все). Фильтр в service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListAgentTasks(
      userId: string,
      statusFilter?: string,
      options?: any,
    ): AxiosPromise<V1ListAgentTasksResponse> {
      return localVarFp
        .agentsServiceListAgentTasks(userId, statusFilter, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary --- Управление агентами + назначение куратора (DEV-430). Authenticated; права в хендлере:     ADMIN/HOS/agents:manage — любого агента/менеджера; MANAGER — только себя («взять агента»). ---
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [searchQuery] FTS по full_name (PostgreSQL to_tsvector), не LIKE.
     * @param {string} [managerId] Фильтр по куратору (user_id менеджера); \&quot;\&quot; игнорируется. Не-привилегированному принудительно выставляется &#x3D; себе (см. хендлер requireAgentsManager).
     * @param {string} [country]
     * @param {string} [language]
     * @param {string} [agentStatus] Структурные фильтры реестра (DEV-471, ТЗ §4.3); \&quot;\&quot; игнорируется.
     * @param {string} [companyId]
     * @param {string} [companyAssignmentStatus] requires_verification &#x3D; «компания не подтверждена»
     * @param {string} [sourceGroup]
     * @param {string} [registeredFrom] created_at &gt;&#x3D;
     * @param {string} [registeredTo] created_at &lt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListAgents(
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      managerId?: string,
      country?: string,
      language?: string,
      agentStatus?: string,
      companyId?: string,
      companyAssignmentStatus?: string,
      sourceGroup?: string,
      registeredFrom?: string,
      registeredTo?: string,
      options?: any,
    ): AxiosPromise<V1ListAgentsResponse> {
      return localVarFp
        .agentsServiceListAgents(
          paginationPage,
          paginationPerPage,
          searchQuery,
          managerId,
          country,
          language,
          agentStatus,
          companyId,
          companyAssignmentStatus,
          sourceGroup,
          registeredFrom,
          registeredTo,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListClientComments — комментарии агента по СВОЕМУ клиенту (агент видит только свои).
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListClientComments(
      clientId: string,
      options?: any,
    ): AxiosPromise<V1ListClientCommentsResponse> {
      return localVarFp
        .agentsServiceListClientComments(clientId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Manager-facing (пермишены на интерцепторе: очередь — agents:read, приём — agents:manage).
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [verificationStatus] \&quot;\&quot; → manager_review
     * @param {string} [responsibleId]
     * @param {string} [agentUserId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListCompanyVerifications(
      paginationPage?: string,
      paginationPerPage?: string,
      verificationStatus?: string,
      responsibleId?: string,
      agentUserId?: string,
      options?: any,
    ): AxiosPromise<V1ListCompanyVerificationsResponse> {
      return localVarFp
        .agentsServiceListCompanyVerifications(
          paginationPage,
          paginationPerPage,
          verificationStatus,
          responsibleId,
          agentUserId,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListDealComments — комментарии агента по СВОЕЙ сделке (агент видит только свои).
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListDealComments(
      dealId: string,
      options?: any,
    ): AxiosPromise<V1ListDealCommentsResponse> {
      return localVarFp
        .agentsServiceListDealComments(dealId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListMyClients — переданные агентом клиенты (agent_id из контекста, DEV-489 §11). Public-safe: маскированное имя, источник, публичный статус клиента; без телефона, внутренних комментариев и чужих клиентов.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyClients(options?: any): AxiosPromise<V1ListMyClientsResponse> {
      return localVarFp
        .agentsServiceListMyClients(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListMyDeals — сделки текущего агента (agent_id из контекста). Имя клиента маскируется («Иван П.»). Для «Мои сделки» и сценариев вознаграждения/встречи (DEV-350, DEV-332).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyDeals(options?: any): AxiosPromise<V1ListMyDealsResponse> {
      return localVarFp
        .agentsServiceListMyDeals(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListMyPresentations — список презентаций текущего агента.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyPresentations(options?: any): AxiosPromise<V1ListMyPresentationsResponse> {
      return localVarFp
        .agentsServiceListMyPresentations(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListMyReferrals — контакты СВОИХ переданных лидов для «Поделиться» презентацией (DEV-1016). Источник — собственные сабмишены агента; §11: canonical client-data не раскрываем. Authenticated + requireAgent (только свои лиды).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyReferrals(options?: any): AxiosPromise<V1ListMyReferralsResponse> {
      return localVarFp
        .agentsServiceListMyReferrals(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary agent (роль AGENT): свои обращения + переписка.
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyTickets(
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      options?: any,
    ): AxiosPromise<V1ListTicketsResponse> {
      return localVarFp
        .agentsServiceListMyTickets(paginationPage, paginationPerPage, status, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [searchQuery] FTS по company_name
     * @param {string} [companyStatus]
     * @param {string} [companyType]
     * @param {string} [responsiblePartnerManagerId]
     * @param {boolean} [includeArchived]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListPartnerCompanies(
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      companyStatus?: string,
      companyType?: string,
      responsiblePartnerManagerId?: string,
      includeArchived?: boolean,
      options?: any,
    ): AxiosPromise<V1ListPartnerCompaniesResponse> {
      return localVarFp
        .agentsServiceListPartnerCompanies(
          paginationPage,
          paginationPerPage,
          searchQuery,
          companyStatus,
          companyType,
          responsiblePartnerManagerId,
          includeArchived,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListPresentationShares — адресные ссылки презентации с per-лид статусами просмотров.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListPresentationShares(
      id: string,
      options?: any,
    ): AxiosPromise<V1ListPresentationSharesResponse> {
      return localVarFp
        .agentsServiceListPresentationShares(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListProjectMaterials — материалы доступного агенту ЖК (презентации/брошюры/прайсы/…); gate available_for_agents && visibility на стороне properties. Ссылки download_url presigned.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListProjectMaterials(
      residentialComplexId: string,
      options?: any,
    ): AxiosPromise<V1ListProjectMaterialsResponse> {
      return localVarFp
        .agentsServiceListProjectMaterials(residentialComplexId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary --- Админ-CRUD правил маршрутизации обращений (DEV-343). Permission agents:admin (проверка в хендлере requireAdmin). ---
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListRoutingRules(options?: any): AxiosPromise<V1ListRoutingRulesResponse> {
      return localVarFp
        .agentsServiceListRoutingRules(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary --- Веб-инбокс тикетов агентов (DEV-432). Authenticated; role-scoping в хендлере:     ADMIN/HOS/agents:manage — все тикеты; MANAGER — только свои (primary/backup/taken_by). ---
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [status] new|in_progress|closed
     * @param {string} [type]
     * @param {boolean} [assignedToMe] только где я ответственный/резерв/взял
     * @param {string} [agentUserId]
     * @param {string} [createdFrom] created_at &gt;&#x3D;
     * @param {string} [createdTo] created_at &lt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListTickets(
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      type?: string,
      assignedToMe?: boolean,
      agentUserId?: string,
      createdFrom?: string,
      createdTo?: string,
      options?: any,
    ): AxiosPromise<V1ListTicketsResponse> {
      return localVarFp
        .agentsServiceListTickets(
          paginationPage,
          paginationPerPage,
          status,
          type,
          assignedToMe,
          agentUserId,
          createdFrom,
          createdTo,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListWebinars — обучающие вебинары + статус участия агента (DEV-489 §10, экран C8).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListWebinars(options?: any): AxiosPromise<V1ListWebinarsResponse> {
      return localVarFp
        .agentsServiceListWebinars(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} ticketId
     * @param {AgentsServicePostAgentTicketMessageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServicePostAgentTicketMessage(
      ticketId: string,
      body: AgentsServicePostAgentTicketMessageBody,
      options?: any,
    ): AxiosPromise<V1PostAgentTicketMessageResponse> {
      return localVarFp
        .agentsServicePostAgentTicketMessage(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary PublishOfferVersion — опубликовать редакцию текста оферты (DEV-616 / ADR-0022). Privileged (agents:manage). trigger_reacceptance=true переводит accepted-агентов с версией ниже в needs_reacceptance в той же транзакции.
     * @param {V1PublishOfferVersionRequest} body PublishOfferVersionRequest — публикация одной языковой редакции оферты (DEV-616 / ADR-0022). version общий для всех языков; язык отдельной записью. Документ — структурный (как GetOffer).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServicePublishOfferVersion(
      body: V1PublishOfferVersionRequest,
      options?: any,
    ): AxiosPromise<V1PublishOfferVersionResponse> {
      return localVarFp
        .agentsServicePublishOfferVersion(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Ошибки ввода отдаются как InvalidArgument (email занят — AlreadyExists) с деталями google.rpc.BadRequest: field = JSON-имя поля запроса, description = код причины (ADR-0031). Клиент подсвечивает поле и локализует текст по коду; плоский message — фолбэк. Реестр кодов (новый код заводится только вместе с i18n-ключом на клиентах):   INVALID_VALUE | INVALID_EMAIL | INVALID_PASSWORD | INVALID_PHONE | INVALID_COUNTRY   EMAIL_TAKEN | AGREEMENT_REQUIRED | CAPTCHA_FAILED | OFFER_VERSION_OUTDATED
     * @summary Register — публичный (gateway + капча Turnstile). Создаёт креду в auth (PENDING), профиль агента и запись принятия оферты. Логин — после подтверждения email.
     * @param {V1RegisterRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRegister(
      body: V1RegisterRequest,
      options?: any,
    ): AxiosPromise<V1RegisterResponse> {
      return localVarFp
        .agentsServiceRegister(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary RegisterForWebinar — регистрация текущего агента на вебинар (роль AGENT).
     * @param {string} webinarId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRegisterForWebinar(
      webinarId: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1RegisterForWebinarResponse> {
      return localVarFp
        .agentsServiceRegisterForWebinar(webinarId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary --- Диалог по обращению (DEV-433). staff/agent — authenticated; *Internal — для бота (public). --- staff: ответ менеджера/РОПа в переписку (опц. взять в работу).
     * @param {string} ticketId
     * @param {AgentsServiceReplyTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceReplyTicket(
      ticketId: string,
      body: AgentsServiceReplyTicketBody,
      options?: any,
    ): AxiosPromise<V1ReplyTicketResponse> {
      return localVarFp
        .agentsServiceReplyTicket(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary RequestMeeting — DEV-347 «Назначить встречу». Создаёт обращение meeting_request по сделке агента (маршрутизация на менеджера сделки); детали — в payload.
     * @param {string} dealId из path
     * @param {AgentsServiceRequestMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRequestMeeting(
      dealId: string,
      body: AgentsServiceRequestMeetingBody,
      options?: any,
    ): AxiosPromise<V1RequestMeetingResponse> {
      return localVarFp
        .agentsServiceRequestMeeting(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary SearchPartnerCompanies — публичные подсказки компаний по префиксу имени для поля «Агентство» на форме регистрации агента (анонимно, DEV-1052). Возвращает минимум (id + имя + город), без чувствительных полей. Отдельный путь (не /companies/{id}, чтобы grpc-gateway не перехватывал подпуть /{id}).
     * @param {string} [query]
     * @param {number} [limit] 0 → дефолт 10
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSearchPartnerCompanies(
      query?: string,
      limit?: number,
      options?: any,
    ): AxiosPromise<V1SearchPartnerCompaniesResponse> {
      return localVarFp
        .agentsServiceSearchPartnerCompanies(query, limit, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary SetAgentCommercialTerms — коммерческая модель агента (DEV-472, ТЗ §9): 30/50/спецусловия. Только privileged (agents:manage); approved_by спецусловий = вызывающий.
     * @param {string} userId
     * @param {AgentsServiceSetAgentCommercialTermsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentCommercialTerms(
      userId: string,
      body: AgentsServiceSetAgentCommercialTermsBody,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceSetAgentCommercialTerms(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary SetAgentOfferStatus — перевод статуса оферты (DEV-472, ТЗ §9.1): sent/needs_reacceptance/ rejected/suspended/not_sent. accepted выставляется потоком принятия, не вручную. Privileged.
     * @param {string} userId
     * @param {AgentsServiceSetAgentOfferStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentOfferStatus(
      userId: string,
      body: AgentsServiceSetAgentOfferStatusBody,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceSetAgentOfferStatus(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary SetAgentStatus — смена жизненного статуса агента (DEV-780): активация («Одобрить», candidate/…→active), неактивность (dormant), архив (archived). Privileged (agents:manage). Ранние статусы (candidate/pending_offer/new_partner/onboarding) выставляются потоками регистрации/онбординга, не этим RPC. Блокировка/разблокировка (blocked) — отдельной задачей. POST на 3-сегментном пути не конфликтует с wildcard GET /agents/{user_id} (DEV-509).
     * @param {string} userId
     * @param {AgentsServiceSetAgentStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentStatus(
      userId: string,
      body: AgentsServiceSetAgentStatusBody,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceSetAgentStatus(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceSetRoutingRuleEnabledBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetRoutingRuleEnabled(
      id: string,
      body: AgentsServiceSetRoutingRuleEnabledBody,
      options?: any,
    ): AxiosPromise<V1RoutingRuleResponse> {
      return localVarFp
        .agentsServiceSetRoutingRuleEnabled(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary SharePresentation — адресная ссылка презентации для конкретного лида (DEV-1017). Идемпотентно: повторный шаринг тому же лиду возвращает существующую ссылку.
     * @param {string} id презентация (path)
     * @param {AgentsServiceSharePresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSharePresentation(
      id: string,
      body: AgentsServiceSharePresentationBody,
      options?: any,
    ): AxiosPromise<V1PresentationShare> {
      return localVarFp
        .agentsServiceSharePresentation(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary SubmitInquiry — DEV-348 «Свободный вопрос». Создаёт обращение из свободного текста для сценариев «Другой вопрос» (other) и «Изучение стратегий → задать вопрос» (strategy_question). Без сделки; маршрутизация по типу (role-based).
     * @param {V1SubmitInquiryRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSubmitInquiry(
      body: V1SubmitInquiryRequest,
      options?: any,
    ): AxiosPromise<V1SubmitInquiryResponse> {
      return localVarFp
        .agentsServiceSubmitInquiry(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary SubmitLead — отправка уведомления о клиенте (защищён, роль AGENT).
     * @param {V1SubmitLeadRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSubmitLead(
      body: V1SubmitLeadRequest,
      options?: any,
    ): AxiosPromise<V1SubmitLeadResponse> {
      return localVarFp
        .agentsServiceSubmitLead(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTakeTicket(
      ticketId: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1TicketActionResponse> {
      return localVarFp
        .agentsServiceTakeTicket(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTransferTicket(
      ticketId: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1TicketActionResponse> {
      return localVarFp
        .agentsServiceTransferTicket(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateMyPresentation — сменить ЖК/язык/название/комментарий (re-snapshot + re-PDF; токен НЕ меняется — отправленная ссылка показывает обновлённую версию).
     * @param {string} id
     * @param {AgentsServiceUpdateMyPresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateMyPresentation(
      id: string,
      body: AgentsServiceUpdateMyPresentationBody,
      options?: any,
    ): AxiosPromise<V1AgentPresentation> {
      return localVarFp
        .agentsServiceUpdateMyPresentation(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateMyProfile — обновить свой профиль (страна/город) текущим агентом (DEV-606).
     * @param {V1UpdateMyProfileRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateMyProfile(
      body: V1UpdateMyProfileRequest,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceUpdateMyProfile(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceUpdatePartnerCompanyBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdatePartnerCompany(
      id: string,
      body: AgentsServiceUpdatePartnerCompanyBody,
      options?: any,
    ): AxiosPromise<V1PartnerCompanyResponse> {
      return localVarFp
        .agentsServiceUpdatePartnerCompany(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {AgentsServiceUpdateRoutingRuleBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateRoutingRule(
      id: string,
      body: AgentsServiceUpdateRoutingRuleBody,
      options?: any,
    ): AxiosPromise<V1RoutingRuleResponse> {
      return localVarFp
        .agentsServiceUpdateRoutingRule(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AgentsServiceApi - object-oriented interface
 * @export
 * @class AgentsServiceApi
 * @extends {BaseAPI}
 */
export class AgentsServiceApi extends BaseAPI {
  /**
   *
   * @summary ArchivePartnerCompany — архивирование (удаление запрещено, ТЗ §13.3). Системную «Частный агент» нельзя.
   * @param {string} id
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceArchivePartnerCompany(
    id: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceArchivePartnerCompany(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary AskCommission — DEV-346 «Вопрос по вознаграждению». Есть дата выплаты — вернуть; иначе создать обращение commission_question (маршрутизация) и сигналить «дата уточняется».
   * @param {string} dealId из path
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceAskCommission(dealId: string, body: object, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceAskCommission(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetAgent (`GET /agents/{user_id}`) объявлен ВЫШЕ — перед GetMyProfile — из-за порядка матчинга grpc-gateway (см. комментарий там). НЕ переносить его сюда. (DEV-509)
   * @param {string} userId агент (из path)
   * @param {AgentsServiceAssignAgentManagerBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceAssignAgentManager(
    userId: string,
    body: AgentsServiceAssignAgentManagerBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceAssignAgentManager(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CheckLeadUnique — проверка телефона клиента (защищён, роль AGENT). Данные найденного клиента не раскрываются (§16).
   * @param {V1CheckLeadUniqueRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCheckLeadUnique(
    body: V1CheckLeadUniqueRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCheckLeadUnique(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} ticketId
   * @param {AgentsServiceCloseTicketBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCloseTicket(
    ticketId: string,
    body: AgentsServiceCloseTicketBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCloseTicket(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} userId
   * @param {string} taskId
   * @param {AgentsServiceCompleteAgentTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCompleteAgentTask(
    userId: string,
    taskId: string,
    body: AgentsServiceCompleteAgentTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCompleteAgentTask(userId, taskId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {V1ConfirmCompanyAssignmentByAgentRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceConfirmCompanyAssignmentByAgent(
    body: V1ConfirmCompanyAssignmentByAgentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceConfirmCompanyAssignmentByAgent(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {AgentsServiceConfirmCompanyAssignmentByManagerBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceConfirmCompanyAssignmentByManager(
    id: string,
    body: AgentsServiceConfirmCompanyAssignmentByManagerBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceConfirmCompanyAssignmentByManager(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateAgent — ручное создание агента менеджером (DEV-470, ADR-0016): заводит PENDING-креду в auth + профиль (created_mode=manual, status=candidate). Дедуп по phone/email/telegram. Права: ADMIN/HOS/agents:manage (requireAgentsManager + privileged).
   * @param {V1CreateAgentRequest} body -------------------- Ручное создание агента (DEV-470) -------------------- Менеджер заводит агента до его входа в панель. email обязателен (PENDING-креда в auth); company_id обязателен (ТЗ §6 — компания обязательна; для одиночки — UUID «Частный агент»).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateAgent(body: V1CreateAgentRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateAgent(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} userId агент (из path)
   * @param {AgentsServiceCreateAgentTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateAgentTask(
    userId: string,
    body: AgentsServiceCreateAgentTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateAgentTask(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateClientComment — комментарий агента по СВОЕМУ клиенту (уведомляет ответственного менеджера).
   * @param {string} clientId из path
   * @param {AgentsServiceCreateClientCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateClientComment(
    clientId: string,
    body: AgentsServiceCreateClientCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateClientComment(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateDealComment — комментарий агента по СВОЕЙ сделке (уведомляет менеджера сделки).
   * @param {string} dealId из path
   * @param {AgentsServiceCreateDealCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateDealComment(
    dealId: string,
    body: AgentsServiceCreateDealCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateDealComment(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateDealTask — задача агента по СВОЕЙ сделке на свободный слот менеджера (409 AlreadyExists, если слот занят). Уведомляет менеджера сделки.
   * @param {string} dealId из path
   * @param {AgentsServiceCreateDealTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateDealTask(
    dealId: string,
    body: AgentsServiceCreateDealTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateDealTask(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateMyPresentation — собрать презентацию по выбранному ЖК (снапшот + токен; PDF генерится асинхронно). Одна презентация = один ЖК.
   * @param {V1CreateMyPresentationRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateMyPresentation(
    body: V1CreateMyPresentationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateMyPresentation(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary --- Компании-партнёры (DEV-469, ТЗ §5). Authenticated; права в хендлере:     чтение — ADMIN/HOS/agents:manage/MANAGER; запись — ADMIN/HOS/agents:manage. ---
   * @param {V1CreatePartnerCompanyRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreatePartnerCompany(
    body: V1CreatePartnerCompanyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreatePartnerCompany(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {V1CreateRoutingRuleRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateRoutingRule(
    body: V1CreateRoutingRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateRoutingRule(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateWebinar — публикация вебинара штатом (DEV-489). Permission agents:manage (ADMIN/HOS) на интерцепторе.
   * @param {V1CreateWebinarRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateWebinar(body: V1CreateWebinarRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateWebinar(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeleteAgentBotLink — отвязать Telegram-бот текущего агента (защищён, роль AGENT). Проксирует agent-bot.UnlinkAgentBinding (DEV-642).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceDeleteAgentBotLink(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceDeleteAgentBotLink(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeleteMyPresentation — мягкое удаление (лендинг по токену → 404).
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceDeleteMyPresentation(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceDeleteMyPresentation(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceDeleteRoutingRule(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceDeleteRoutingRule(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ВНИМАНИЕ, ПОРЯДОК (grpc-gateway): catch-all `GET /agents/{user_id}` (GetAgent) ДОЛЖЕН быть объявлен ПЕРВЫМ среди GET-методов. runtime.ServeMux.Handle делает prepend, поэтому later-registered маршрут матчится РАНЬШЕ, а специфичность/литералы НЕ приоритизируются. Объявив wildcard первым, кладём его в конец цепочки матчинга → статические `/agents/<literal>` (me, routing-rules, tickets, companies) перехватывают раньше него. НЕ добавлять статические GET-маршруты /agents/_* ВЫШЕ этого rpc. (DEV-509)
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgent(userId: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgent(userId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetAgentBotLinkCode — одноразовый код привязки Telegram-бота + deep-link (защищён, роль AGENT). Для «Подключить бота» в агентской панели (DEV-341/353).
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentBotLinkCode(body: object, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentBotLinkCode(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetAgentBotStatus — статус привязки Telegram-бота агента (защищён, роль AGENT). Проксирует agent-bot.GetAgentBinding — единый источник правды по привязке (DEV-642 / ADR-0023). ВАЖНО (DEV-509): статический GET /agents/me/bot-status объявлен НИЖЕ GetAgent.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentBotStatus(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentBotStatus(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetAgentDashboard — KPI кабинета агента (DEV-489): передано клиентов, активные сделки, депозиты, прогноз вознаграждения, последняя активность, ближайшая задача.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentDashboard(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentDashboard(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetAgentDeals — сделки агента для карточки штата (DEV-780): реальные имена клиентов (в отличие от кабинета агента, где маскируются) + агрегаты вознаграждения (начислено/к выплате). Штат-скоуп в хендлере (MANAGER — свои подопечные, ADMIN/HOS — все). Данные — из deals-service (per-deal reward-поля; «история» пока там же). ВАЖНО (класс DEV-509): wildcard GET /agents/{user_id}/deals объявлен ВЫШЕ статического /agents/me/deals (ListMyDeals) той же длины — иначе later-registered wildcard перехватывает /me/deals (prepend-матчинг grpc-gateway, литералы не приоритизируются) → 403 agents:read вместо кабинета агента. НЕ опускать ниже ListMyDeals.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentDeals(userId: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentDeals(userId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetCompanyVerification(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetCompanyVerification(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetDealFreeSlots — свободные слоты менеджера СВОЕЙ сделки (запись задачи/встречи). from/to опц.
   * @param {string} dealId
   * @param {string} [from] опц. начало окна (query, RFC3339)
   * @param {string} [to] опц. конец окна (query, RFC3339)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetDealFreeSlots(
    dealId: string,
    from?: string,
    to?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetDealFreeSlots(dealId, from, to, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary --- Верификация компании агента (DEV-791, RFC §9). --- Agent-facing (роль AGENT, только своё; requireAgent в хендлере): просмотр кандидатов и выбор.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetMyCompanyVerification(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetMyCompanyVerification(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetMyPresentation — карточка презентации (владелец).
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetMyPresentation(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetMyPresentation(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetMyProfile — профиль текущего агента (защищён, роль AGENT).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetMyProfile(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetMyProfile(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetMyTicket(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetMyTicket(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetOffer — публичная актуальная (или конкретная по version) редакция оферты. Язык — через user-locale (заголовок). Без токена, как Register. DEV-616 / ADR-0022. ВАЖНО (DEV-509/DEV-638): объявлен НИЖЕ GetAgent — статический GET /agents/offer иначе перехватывается wildcard GET /agents/{user_id} (grpc-gateway prepend) → 403 agents:read.
   * @param {number} [version]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetOffer(version?: number, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetOffer(version, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetPartnerCompany(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetPartnerCompany(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetPublicPresentation — публичный резолв по токену для лендинга vinprop.vn/p/{token} (без auth). Трекает просмотр (view_count++, событие presentation.viewed).
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetPublicPresentation(token: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetPublicPresentation(token, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetStaffBotLinkCode — код привязки сотрудника к agency-боту для уведомлений (authenticated, DEV-344).
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetStaffBotLinkCode(body: object, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetStaffBotLinkCode(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetTicket(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetTicket(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary --- Задачи агента (DEV-511, владелец agent_tasks; зеркало deals Task). Authenticated;     скоуп «свои/все» по роли в хендлере. Чтение — agents:read, запись — agents:update.     Маршруты 3-сегментные (/{user_id}/tasks...) не конфликтуют с wildcard GetAgent (DEV-509). ---
   * @param {string} userId
   * @param {string} [statusFilter] open | done | \&quot;\&quot; (все). Фильтр в service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListAgentTasks(
    userId: string,
    statusFilter?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListAgentTasks(userId, statusFilter, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary --- Управление агентами + назначение куратора (DEV-430). Authenticated; права в хендлере:     ADMIN/HOS/agents:manage — любого агента/менеджера; MANAGER — только себя («взять агента»). ---
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [searchQuery] FTS по full_name (PostgreSQL to_tsvector), не LIKE.
   * @param {string} [managerId] Фильтр по куратору (user_id менеджера); \&quot;\&quot; игнорируется. Не-привилегированному принудительно выставляется &#x3D; себе (см. хендлер requireAgentsManager).
   * @param {string} [country]
   * @param {string} [language]
   * @param {string} [agentStatus] Структурные фильтры реестра (DEV-471, ТЗ §4.3); \&quot;\&quot; игнорируется.
   * @param {string} [companyId]
   * @param {string} [companyAssignmentStatus] requires_verification &#x3D; «компания не подтверждена»
   * @param {string} [sourceGroup]
   * @param {string} [registeredFrom] created_at &gt;&#x3D;
   * @param {string} [registeredTo] created_at &lt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListAgents(
    paginationPage?: string,
    paginationPerPage?: string,
    searchQuery?: string,
    managerId?: string,
    country?: string,
    language?: string,
    agentStatus?: string,
    companyId?: string,
    companyAssignmentStatus?: string,
    sourceGroup?: string,
    registeredFrom?: string,
    registeredTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListAgents(
        paginationPage,
        paginationPerPage,
        searchQuery,
        managerId,
        country,
        language,
        agentStatus,
        companyId,
        companyAssignmentStatus,
        sourceGroup,
        registeredFrom,
        registeredTo,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListClientComments — комментарии агента по СВОЕМУ клиенту (агент видит только свои).
   * @param {string} clientId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListClientComments(clientId: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListClientComments(clientId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Manager-facing (пермишены на интерцепторе: очередь — agents:read, приём — agents:manage).
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [verificationStatus] \&quot;\&quot; → manager_review
   * @param {string} [responsibleId]
   * @param {string} [agentUserId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListCompanyVerifications(
    paginationPage?: string,
    paginationPerPage?: string,
    verificationStatus?: string,
    responsibleId?: string,
    agentUserId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListCompanyVerifications(
        paginationPage,
        paginationPerPage,
        verificationStatus,
        responsibleId,
        agentUserId,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListDealComments — комментарии агента по СВОЕЙ сделке (агент видит только свои).
   * @param {string} dealId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListDealComments(dealId: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListDealComments(dealId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListMyClients — переданные агентом клиенты (agent_id из контекста, DEV-489 §11). Public-safe: маскированное имя, источник, публичный статус клиента; без телефона, внутренних комментариев и чужих клиентов.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyClients(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyClients(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListMyDeals — сделки текущего агента (agent_id из контекста). Имя клиента маскируется («Иван П.»). Для «Мои сделки» и сценариев вознаграждения/встречи (DEV-350, DEV-332).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyDeals(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyDeals(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListMyPresentations — список презентаций текущего агента.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyPresentations(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyPresentations(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListMyReferrals — контакты СВОИХ переданных лидов для «Поделиться» презентацией (DEV-1016). Источник — собственные сабмишены агента; §11: canonical client-data не раскрываем. Authenticated + requireAgent (только свои лиды).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyReferrals(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyReferrals(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary agent (роль AGENT): свои обращения + переписка.
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [status]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyTickets(
    paginationPage?: string,
    paginationPerPage?: string,
    status?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyTickets(paginationPage, paginationPerPage, status, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [searchQuery] FTS по company_name
   * @param {string} [companyStatus]
   * @param {string} [companyType]
   * @param {string} [responsiblePartnerManagerId]
   * @param {boolean} [includeArchived]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListPartnerCompanies(
    paginationPage?: string,
    paginationPerPage?: string,
    searchQuery?: string,
    companyStatus?: string,
    companyType?: string,
    responsiblePartnerManagerId?: string,
    includeArchived?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListPartnerCompanies(
        paginationPage,
        paginationPerPage,
        searchQuery,
        companyStatus,
        companyType,
        responsiblePartnerManagerId,
        includeArchived,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListPresentationShares — адресные ссылки презентации с per-лид статусами просмотров.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListPresentationShares(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListPresentationShares(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListProjectMaterials — материалы доступного агенту ЖК (презентации/брошюры/прайсы/…); gate available_for_agents && visibility на стороне properties. Ссылки download_url presigned.
   * @param {string} residentialComplexId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListProjectMaterials(
    residentialComplexId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListProjectMaterials(residentialComplexId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary --- Админ-CRUD правил маршрутизации обращений (DEV-343). Permission agents:admin (проверка в хендлере requireAdmin). ---
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListRoutingRules(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListRoutingRules(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary --- Веб-инбокс тикетов агентов (DEV-432). Authenticated; role-scoping в хендлере:     ADMIN/HOS/agents:manage — все тикеты; MANAGER — только свои (primary/backup/taken_by). ---
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [status] new|in_progress|closed
   * @param {string} [type]
   * @param {boolean} [assignedToMe] только где я ответственный/резерв/взял
   * @param {string} [agentUserId]
   * @param {string} [createdFrom] created_at &gt;&#x3D;
   * @param {string} [createdTo] created_at &lt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListTickets(
    paginationPage?: string,
    paginationPerPage?: string,
    status?: string,
    type?: string,
    assignedToMe?: boolean,
    agentUserId?: string,
    createdFrom?: string,
    createdTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListTickets(
        paginationPage,
        paginationPerPage,
        status,
        type,
        assignedToMe,
        agentUserId,
        createdFrom,
        createdTo,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListWebinars — обучающие вебинары + статус участия агента (DEV-489 §10, экран C8).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListWebinars(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListWebinars(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} ticketId
   * @param {AgentsServicePostAgentTicketMessageBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServicePostAgentTicketMessage(
    ticketId: string,
    body: AgentsServicePostAgentTicketMessageBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServicePostAgentTicketMessage(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary PublishOfferVersion — опубликовать редакцию текста оферты (DEV-616 / ADR-0022). Privileged (agents:manage). trigger_reacceptance=true переводит accepted-агентов с версией ниже в needs_reacceptance в той же транзакции.
   * @param {V1PublishOfferVersionRequest} body PublishOfferVersionRequest — публикация одной языковой редакции оферты (DEV-616 / ADR-0022). version общий для всех языков; язык отдельной записью. Документ — структурный (как GetOffer).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServicePublishOfferVersion(
    body: V1PublishOfferVersionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServicePublishOfferVersion(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Ошибки ввода отдаются как InvalidArgument (email занят — AlreadyExists) с деталями google.rpc.BadRequest: field = JSON-имя поля запроса, description = код причины (ADR-0031). Клиент подсвечивает поле и локализует текст по коду; плоский message — фолбэк. Реестр кодов (новый код заводится только вместе с i18n-ключом на клиентах):   INVALID_VALUE | INVALID_EMAIL | INVALID_PASSWORD | INVALID_PHONE | INVALID_COUNTRY   EMAIL_TAKEN | AGREEMENT_REQUIRED | CAPTCHA_FAILED | OFFER_VERSION_OUTDATED
   * @summary Register — публичный (gateway + капча Turnstile). Создаёт креду в auth (PENDING), профиль агента и запись принятия оферты. Логин — после подтверждения email.
   * @param {V1RegisterRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceRegister(body: V1RegisterRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceRegister(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary RegisterForWebinar — регистрация текущего агента на вебинар (роль AGENT).
   * @param {string} webinarId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceRegisterForWebinar(
    webinarId: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceRegisterForWebinar(webinarId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary --- Диалог по обращению (DEV-433). staff/agent — authenticated; *Internal — для бота (public). --- staff: ответ менеджера/РОПа в переписку (опц. взять в работу).
   * @param {string} ticketId
   * @param {AgentsServiceReplyTicketBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceReplyTicket(
    ticketId: string,
    body: AgentsServiceReplyTicketBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceReplyTicket(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary RequestMeeting — DEV-347 «Назначить встречу». Создаёт обращение meeting_request по сделке агента (маршрутизация на менеджера сделки); детали — в payload.
   * @param {string} dealId из path
   * @param {AgentsServiceRequestMeetingBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceRequestMeeting(
    dealId: string,
    body: AgentsServiceRequestMeetingBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceRequestMeeting(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary SearchPartnerCompanies — публичные подсказки компаний по префиксу имени для поля «Агентство» на форме регистрации агента (анонимно, DEV-1052). Возвращает минимум (id + имя + город), без чувствительных полей. Отдельный путь (не /companies/{id}, чтобы grpc-gateway не перехватывал подпуть /{id}).
   * @param {string} [query]
   * @param {number} [limit] 0 → дефолт 10
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSearchPartnerCompanies(
    query?: string,
    limit?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSearchPartnerCompanies(query, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary SetAgentCommercialTerms — коммерческая модель агента (DEV-472, ТЗ §9): 30/50/спецусловия. Только privileged (agents:manage); approved_by спецусловий = вызывающий.
   * @param {string} userId
   * @param {AgentsServiceSetAgentCommercialTermsBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSetAgentCommercialTerms(
    userId: string,
    body: AgentsServiceSetAgentCommercialTermsBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSetAgentCommercialTerms(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary SetAgentOfferStatus — перевод статуса оферты (DEV-472, ТЗ §9.1): sent/needs_reacceptance/ rejected/suspended/not_sent. accepted выставляется потоком принятия, не вручную. Privileged.
   * @param {string} userId
   * @param {AgentsServiceSetAgentOfferStatusBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSetAgentOfferStatus(
    userId: string,
    body: AgentsServiceSetAgentOfferStatusBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSetAgentOfferStatus(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary SetAgentStatus — смена жизненного статуса агента (DEV-780): активация («Одобрить», candidate/…→active), неактивность (dormant), архив (archived). Privileged (agents:manage). Ранние статусы (candidate/pending_offer/new_partner/onboarding) выставляются потоками регистрации/онбординга, не этим RPC. Блокировка/разблокировка (blocked) — отдельной задачей. POST на 3-сегментном пути не конфликтует с wildcard GET /agents/{user_id} (DEV-509).
   * @param {string} userId
   * @param {AgentsServiceSetAgentStatusBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSetAgentStatus(
    userId: string,
    body: AgentsServiceSetAgentStatusBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSetAgentStatus(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {AgentsServiceSetRoutingRuleEnabledBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSetRoutingRuleEnabled(
    id: string,
    body: AgentsServiceSetRoutingRuleEnabledBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSetRoutingRuleEnabled(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary SharePresentation — адресная ссылка презентации для конкретного лида (DEV-1017). Идемпотентно: повторный шаринг тому же лиду возвращает существующую ссылку.
   * @param {string} id презентация (path)
   * @param {AgentsServiceSharePresentationBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSharePresentation(
    id: string,
    body: AgentsServiceSharePresentationBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSharePresentation(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary SubmitInquiry — DEV-348 «Свободный вопрос». Создаёт обращение из свободного текста для сценариев «Другой вопрос» (other) и «Изучение стратегий → задать вопрос» (strategy_question). Без сделки; маршрутизация по типу (role-based).
   * @param {V1SubmitInquiryRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSubmitInquiry(body: V1SubmitInquiryRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSubmitInquiry(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary SubmitLead — отправка уведомления о клиенте (защищён, роль AGENT).
   * @param {V1SubmitLeadRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSubmitLead(body: V1SubmitLeadRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSubmitLead(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} ticketId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceTakeTicket(ticketId: string, body: object, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceTakeTicket(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} ticketId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceTransferTicket(
    ticketId: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceTransferTicket(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateMyPresentation — сменить ЖК/язык/название/комментарий (re-snapshot + re-PDF; токен НЕ меняется — отправленная ссылка показывает обновлённую версию).
   * @param {string} id
   * @param {AgentsServiceUpdateMyPresentationBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceUpdateMyPresentation(
    id: string,
    body: AgentsServiceUpdateMyPresentationBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceUpdateMyPresentation(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateMyProfile — обновить свой профиль (страна/город) текущим агентом (DEV-606).
   * @param {V1UpdateMyProfileRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceUpdateMyProfile(
    body: V1UpdateMyProfileRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceUpdateMyProfile(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {AgentsServiceUpdatePartnerCompanyBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceUpdatePartnerCompany(
    id: string,
    body: AgentsServiceUpdatePartnerCompanyBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceUpdatePartnerCompany(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {AgentsServiceUpdateRoutingRuleBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceUpdateRoutingRule(
    id: string,
    body: AgentsServiceUpdateRoutingRuleBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceUpdateRoutingRule(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
